(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    // Persist boutique + mode as cart attributes. Boutique préférée is a
    // preference (checkout does not overwrite it). Mode de livraison is
    // written only on an explicit PDP/banner click — stamping it from
    // localStorage on every page load left Ramassage on home-delivery
    // orders because checkout shipping does not overwrite cart attrs.
    // Native checkout remains the source of truth; vp-app snaps Mode
    // from staff/FO state on paid / Convert.
    var PICKUP_ATTR = 'Boutique préférée';
    var MODE_ATTR = 'Mode de livraison';
    var STORE_KEY = 'vp_selected_store';
    var MODE_KEY = 'vp_fulfillment_mode';
    var MODE_LABELS = { pickup: 'Ramassage en boutique', delivery: 'Livraison à domicile' };

    function setCartAttribute(name, value) {
      if (!value) return;
      var body = {};
      body['attributes[' + name + ']'] = value;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(body).toString()
      }).catch(function() {});
    }

    // Toggle the displayed pickup/delivery line in the drawer footer.
    function applyFulfillmentMode(mode) {
      var el = document.querySelector('[data-cart-fulfillment]');
      if (el) el.setAttribute('data-mode', mode === 'delivery' ? 'delivery' : 'pickup');
    }

    var savedStore = localStorage.getItem(STORE_KEY);
    var savedMode = localStorage.getItem(MODE_KEY) === 'pickup' ? 'pickup' : 'delivery';
    if (savedStore) setCartAttribute(PICKUP_ATTR, savedStore);
    applyFulfillmentMode(savedMode);
    refreshPickupClaim(savedStore);

    // O-1673 — garder la boutique choisie. Liquid tranche au re-rendu du
    // panier ; ce recalcul couvre le changement de boutique sans reload.
    function refreshPickupClaim(selected) {
      var el = document.querySelector('[data-cart-fulfillment]');
      if (!el || !selected) return;
      var viable = (el.getAttribute('data-pickup-viable') || '').split('|').filter(Boolean);
      var transfer = el.querySelector('[data-pickup-transfer]');
      var nudge = el.querySelector('[data-pickup-nudge]');
      var nameEl = el.querySelector('[data-store-name]');
      if (nameEl) nameEl.textContent = selected;
      var ok = viable.indexOf(selected) !== -1;
      if (transfer) {
        transfer.hidden = ok;
        if (!ok) {
          var tpl = el.getAttribute('data-msg-transfer') || '';
          if (tpl.indexOf('&') !== -1) {
            var decoder = document.createElement('textarea');
            decoder.innerHTML = tpl;
            tpl = decoder.value;
          }
          transfer.textContent = tpl.replace('@@', selected);
        }
      }
      if (nudge) nudge.hidden = !ok;
    }

    window.addEventListener('vp:store-changed', function(e) {
      if (e.detail && e.detail.store) {
        setCartAttribute(PICKUP_ATTR, e.detail.store);
        refreshPickupClaim(e.detail.store);
      }
    });

    window.addEventListener('vp:fulfillment-changed', function(e) {
      var mode = e.detail && e.detail.mode === 'delivery' ? 'delivery' : 'pickup';
      setCartAttribute(MODE_ATTR, MODE_LABELS[mode]);
      applyFulfillmentMode(mode);
    });

    var countEl = document.getElementById('cart-drawer-count');
    var headerBadge = document.getElementById('cart-count');
    var bodyEl = document.getElementById('cart-drawer-body');
    var footerEl = document.getElementById('cart-drawer-footer');
    var subtotalEl = document.getElementById('cart-drawer-subtotal');

    function isEcofeeLine(item) {
      if (typeof window.vpIsEcofeeItem === 'function' && window.vpIsEcofeeItem(item)) return true;
      if (typeof window.vpIsDoorInversionItem === 'function' && window.vpIsDoorInversionItem(item)) return true;
      if (!item) return false;
      var sku = String(item.sku || '').toUpperCase();
      var handle = item.handle || '';
      var type = item.product_type || '';
      if (handle === 'ecofrais' || type === 'Écofrais' || sku.indexOf('ECOFRAIS') === 0) return true;
      if (handle === 'inversion-porte' || type === 'Inversion de porte' || sku === 'INVERSION-PORTE') return true;
      return false;
    }

    function visibleCartCount(cart) {
      if (!cart || !cart.items) return 0;
      var n = 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (isEcofeeLine(cart.items[i])) continue;
        n += cart.items[i].quantity || 0;
      }
      return n;
    }

    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      updateAccessoryNav();
    }

    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-open-cart]').forEach(function(btn) {
      btn.addEventListener('click', function(e) { e.preventDefault(); open(); });
    });
    drawer.querySelectorAll('[data-cart-close]').forEach(function(el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });

    function formatMoney(cents) {
      if (typeof window.vpFormatMoney === 'function') return window.vpFormatMoney(cents);
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
      return '$' + (cents / 100).toFixed(2);
    }

    /* Free gift lines (gift-cart.liquid) move with their product in the same
       request; otherwise Shopify first renders the product or the gift split
       over two lines, and the drawer flickers through that state. */
    function changeRequest(keyQuantities) {
      var updates = {};
      Object.keys(keyQuantities).forEach(function(key) {
        var gift = window.vpGiftUpdates ? window.vpGiftUpdates(key, keyQuantities[key]) : {};
        Object.keys(gift).forEach(function(k) { updates[k] = gift[k]; });
      });
      if (!Object.keys(updates).length) return null;
      Object.keys(keyQuantities).forEach(function(key) { updates[key] = keyQuantities[key]; });
      return fetch('/cart/update.js?sections=cart-drawer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }

    function sendQuantities(keyQuantities) {
      var keys = Object.keys(keyQuantities);
      var single = keys.length === 1;
      return (changeRequest(keyQuantities) || fetch(single ? '/cart/change.js?sections=cart-drawer' : '/cart/update.js?sections=cart-drawer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(single ? { id: keys[0], quantity: keyQuantities[keys[0]] } : { updates: keyQuantities })
      }))
      .then(function(r) { return r.json(); })
      .then(function(json) {
        if (window.vpGiftSeen) window.vpGiftSeen(json);
        if (json.sections && json.sections['cart-drawer']) {
          refreshDrawerFromSection(json.sections['cart-drawer']);
        } else {
          refreshDrawer(json);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { silent: true }
        }));
      });
    }

    /* +/−: the count changes on screen at once and one request leaves when
       the clicks stop. Clicks wait while it is in flight: Shopify re-keys
       lines on every update, so a request built from the old drawer would
       target stale lines and leave the product or its gift split in two. */
    var pendingQty = [];
    var qtyTimer = null;
    var qtyBusy = false;
    var QTY_SETTLE_MS = 350;

    function queueQty(item, nextQty) {
      if (qtyBusy) return;
      item.querySelector('[data-cart-qty-value]').textContent = nextQty;
      var entry = pendingQty.filter(function(p) { return p.item === item; })[0];
      if (entry) entry.qty = nextQty;
      else pendingQty.push({ item: item, qty: nextQty });
      clearTimeout(qtyTimer);
      qtyTimer = setTimeout(flushQty, QTY_SETTLE_MS);
    }

    function flushQty() {
      var keyQuantities = {};
      pendingQty.forEach(function(p) {
        keyQuantities[p.item.getAttribute('data-key')] = p.qty;
        var planKey = p.item.getAttribute('data-protection-key');
        if (p.qty === 0 && planKey) keyQuantities[planKey] = 0;
      });
      pendingQty = [];
      qtyBusy = true;
      drawer.classList.add('is-qty-busy');
      var release = function() {
        qtyBusy = false;
        drawer.classList.remove('is-qty-busy');
      };
      sendQuantities(keyQuantities).then(release, release);
    }

    /* Remove one or more line items by key (quantity 0), repainting the drawer
       only once — after the last removal. */
    function removeKeys(keys) {
      var zeroed = {};
      keys.forEach(function(key) { zeroed[key] = 0; });
      var together = changeRequest(zeroed);
      if (together) {
        together
          .then(function(r) { return r.json(); })
          .then(function(json) {
            if (json.sections && json.sections['cart-drawer']) {
              refreshDrawerFromSection(json.sections['cart-drawer']);
            } else {
              refreshDrawer(json);
            }
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { silent: true }
            }));
          });
        return;
      }
      function step(i) {
        var isLast = i >= keys.length - 1;
        fetch('/cart/change.js' + (isLast ? '?sections=cart-drawer' : ''), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: keys[i], quantity: 0 })
        })
        .then(function(r) { return r.json(); })
        .then(function(json) {
          if (!isLast) { step(i + 1); return; }
          if (json.sections && json.sections['cart-drawer']) {
            refreshDrawerFromSection(json.sections['cart-drawer']);
          } else {
            refreshDrawer(json);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { silent: true }
          }));
        });
      }
      if (keys.length) step(0);
    }

    /* Remove a cart line, plus its linked protection plan if it carries one
       (data-protection-key), so the plan never orphans when its item leaves. */
    function removeItemWithProtection(itemEl) {
      var keys = [itemEl.getAttribute('data-key')];
      var planKey = itemEl.getAttribute('data-protection-key');
      if (planKey) keys.push(planKey);
      removeKeys(keys);
    }

    /* Swap the drawer's body + footer with freshly-rendered Liquid HTML
       returned by the Section Rendering API. Lets the protection-plan
       nesting and upsell card update on every cart mutation, which the
       JSON-only `createItemEl` path couldn't do (no metafield access). */
    function refreshDrawerFromSection(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var newBody = doc.querySelector('#cart-drawer-body');
      var oldBody = document.getElementById('cart-drawer-body');
      var oldRects = itemRects(oldBody);
      if (newBody && oldBody) oldBody.replaceWith(newBody);
      animateItems(oldRects, newBody);

      var newFooter = doc.querySelector('#cart-drawer-footer');
      var oldFooter = document.getElementById('cart-drawer-footer');
      if (newFooter && oldFooter) {
        oldFooter.replaceWith(newFooter);
      } else if (newFooter && !oldFooter) {
        // Empty-cart state previously hid the footer; re-attach when items return.
        var panel = drawer.querySelector('.cart-drawer__panel');
        if (panel) panel.appendChild(newFooter);
      }

      // Re-apply the chosen mode + store claim to the freshly-rendered footer.
      applyFulfillmentMode(localStorage.getItem(MODE_KEY) === 'pickup' ? 'pickup' : 'delivery');
      refreshPickupClaim(localStorage.getItem(STORE_KEY));

      var newCount = doc.querySelector('#cart-drawer-count');
      var count = newCount ? (parseInt(newCount.textContent, 10) || 0) : 0;
      if (countEl) countEl.textContent = count;
      if (headerBadge) {
        headerBadge.textContent = count;
        headerBadge.style.display = count > 0 ? '' : 'none';
      }
      updateAccessoryNav();
    }

    /* FLIP on re-render: lines already shown glide to their new place, new
       lines (e.g. the free gift added right after the product) fade in,
       instead of the whole list jumping. */
    function itemRects(body) {
      var rects = {};
      if (!body) return rects;
      body.querySelectorAll('[data-cart-item][data-key]').forEach(function(el) {
        var key = el.getAttribute('data-key');
        var rect = el.getBoundingClientRect();
        rects[key] = rect;
        // Shopify re-keys a line when its discounts change (the gift's BXGY
        // touches the product it rewards), so also match on the variant id.
        var variant = 'v:' + key.split(':')[0];
        rects[variant] = variant in rects ? null : rect;
      });
      return rects;
    }

    function animateItems(oldRects, body) {
      if (!body || !Object.keys(oldRects).length || !body.animate) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var easing = 'cubic-bezier(0.2, 0.7, 0.2, 1)';
      body.querySelectorAll('[data-cart-item][data-key]').forEach(function(el) {
        var key = el.getAttribute('data-key');
        var before = oldRects[key] || oldRects['v:' + key.split(':')[0]];
        if (!before) {
          el.animate(
            [{ opacity: 0, transform: 'translateY(-8px)' }, { opacity: 1, transform: 'none' }],
            { duration: 360, delay: 80, easing: easing, fill: 'backwards' }
          );
          return;
        }
        var dy = before.top - el.getBoundingClientRect().top;
        if (Math.abs(dy) < 1) return;
        el.animate(
          [{ transform: 'translateY(' + dy + 'px)' }, { transform: 'none' }],
          { duration: 300, easing: easing }
        );
      });
    }

    function createItemEl(item) {
      var wrapper = document.createElement('div');
      wrapper.className = 'cart-drawer__item' + (item.properties && item.properties._vp_gift ? ' cart-drawer__item--gift' : '');
      wrapper.setAttribute('data-cart-item', '');
      wrapper.setAttribute('data-key', item.key);

      var imgLink = document.createElement('a');
      imgLink.href = item.url;
      imgLink.className = 'cart-drawer__item-image';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.featured_image && item.featured_image.url
          ? item.featured_image.url.replace(/\?.*/, '') + '?width=200'
          : item.image;
        img.loading = 'lazy';
        img.alt = '';
        imgLink.appendChild(img);
      }
      wrapper.appendChild(imgLink);

      var info = document.createElement('div');
      info.className = 'cart-drawer__item-info';

      var titleLink = document.createElement('a');
      titleLink.href = item.url;
      titleLink.className = 'cart-drawer__item-title';
      titleLink.textContent = item.product_title;
      info.appendChild(titleLink);

      var meta = document.createElement('div');
      meta.className = 'cart-drawer__item-meta';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var options = item.options_with_values || [];
        if (options.length) {
          options.forEach(function(option) {
            var variant = document.createElement('p');
            variant.className = 'cart-drawer__item-variant';
            var label = document.createElement('span');
            label.className = 'cart-drawer__item-variant-label';
            label.textContent = option.name + ':';
            var value = document.createElement('span');
            value.className = 'cart-drawer__item-variant-value';
            value.textContent = option.value;
            variant.appendChild(label);
            variant.appendChild(document.createTextNode(' '));
            variant.appendChild(value);
            meta.appendChild(variant);
          });
        } else {
          var variant = document.createElement('p');
          variant.className = 'cart-drawer__item-variant';
          variant.textContent = item.variant_title;
          meta.appendChild(variant);
        }
      }

      var props = item.properties || {};
      Object.keys(props).forEach(function(key) {
        if (!key || key.charAt(0) === '_' || !props[key]) return;
        var propEl = document.createElement('p');
        propEl.className = 'cart-drawer__item-variant';
        var pLabel = document.createElement('span');
        pLabel.className = 'cart-drawer__item-variant-label';
        pLabel.textContent = key + ':';
        var pValue = document.createElement('span');
        pValue.className = 'cart-drawer__item-variant-value';
        pValue.textContent = props[key];
        propEl.appendChild(pLabel);
        propEl.appendChild(document.createTextNode(' '));
        propEl.appendChild(pValue);
        meta.appendChild(propEl);
      });
      info.appendChild(meta);
      if (props.Gravure) {
        var so = document.createElement('p');
        so.className = 'cart-drawer__item-special-order';
        var drawer = document.getElementById('cart-drawer');
        so.textContent = (drawer && drawer.getAttribute('data-engraving-special-order'))
          || ((document.documentElement.lang === 'fr' ? 'Commande spéciale' : 'Special order') + ': 10 to 12 weeks');
        info.appendChild(so);
      }

      var bottom = document.createElement('div');
      bottom.className = 'cart-drawer__item-bottom';
      if (item.original_line_price > item.final_line_price) {
        bottom.className += ' cart-drawer__item-bottom--sale';
      }

      var actions = document.createElement('div');
      actions.className = 'cart-drawer__item-actions';

      var removeBtn = document.createElement('button');
      removeBtn.className = 'cart-drawer__item-remove';
      removeBtn.setAttribute('data-cart-remove', '');
      removeBtn.setAttribute('aria-label', 'Remove');
      removeBtn.innerHTML = '<svg width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M3 5h14" stroke-width="1.5" stroke-linecap="round"/><path d="M8 5V3.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 5l.867 11.28A1.5 1.5 0 0 0 7.361 17.5h5.278a1.5 1.5 0 0 0 1.494-1.22L15 5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var qtyControl = document.createElement('div');
      qtyControl.className = 'cart-drawer__qty-control';
      var minusBtn = document.createElement('button');
      minusBtn.className = 'cart-drawer__qty-btn';
      minusBtn.setAttribute('data-cart-qty-minus', '');
      minusBtn.textContent = '\u2212';
      var qtyValue = document.createElement('span');
      qtyValue.className = 'cart-drawer__qty-value';
      qtyValue.setAttribute('data-cart-qty-value', '');
      qtyValue.textContent = item.quantity;
      var plusBtn = document.createElement('button');
      plusBtn.className = 'cart-drawer__qty-btn';
      plusBtn.setAttribute('data-cart-qty-plus', '');
      plusBtn.textContent = '+';
      qtyControl.appendChild(minusBtn);
      qtyControl.appendChild(qtyValue);
      qtyControl.appendChild(plusBtn);
      actions.appendChild(qtyControl);
      actions.appendChild(removeBtn);

      var price = document.createElement('span');
      price.className = 'cart-drawer__item-price';
      // Le prix barré est reconstruit ici aussi : ce chemin JS remplace la
      // ligne entière après un changement de quantité, et se contenter du
      // prix final ferait disparaître la remise au premier clic sur « + ».
      if (item.original_line_price > item.final_line_price) {
        var was = document.createElement('s');
        was.className = 'cart-drawer__item-price-was';
        was.textContent = formatMoney(item.original_line_price);
        price.appendChild(was);
      }
      var now = document.createElement('span');
      now.className = 'cart-drawer__item-price-now';
      if (item.original_line_price > item.final_line_price) {
        now.className += ' cart-drawer__item-price-now--sale';
      }
      now.textContent = formatMoney(item.final_line_price);
      price.appendChild(now);

      var priceRow = document.createElement('div');
      priceRow.className = 'cart-drawer__item-price-row';
      priceRow.appendChild(price);

      bottom.appendChild(priceRow);
      bottom.appendChild(actions);
      info.appendChild(bottom);
      wrapper.appendChild(info);

      return wrapper;
    }

    function doorFeeUnitCents(cart) {
      if (cart && cart.items) {
        for (var i = 0; i < cart.items.length; i++) {
          if (typeof window.vpIsDoorInversionItem === 'function' && window.vpIsDoorInversionItem(cart.items[i])) {
            return cart.items[i].final_price || 0;
          }
        }
      }
      if (window.vpDoorInversion) {
        var unit = parseFloat(window.vpDoorInversion.amount);
        if (unit && isFinite(unit) && unit > 0) return Math.round(unit * 100);
      }
      return 0;
    }

    function formatMoneyPlus(cents) {
      var m = formatMoney(cents);
      if (!m) return m;
      if (m.charAt(0) === '+') return m;
      if (m.charAt(0) === '$') return '+' + m;
      return '+ ' + m;
    }

    function createDoorFeeRow(item, unitCents) {
      var skuIsPg = typeof window.vpSkuEndsPg === 'function'
        ? window.vpSkuEndsPg(item.sku)
        : /(?:-PG)$/i.test(String(item.sku || '').trim());
      if (!skuIsPg || !unitCents) return null;
      var row = document.createElement('div');
      row.className = 'cart-drawer__door-fee';
      var title = document.createElement('span');
      title.className = 'cart-drawer__door-fee-title';
      title.textContent = drawer.getAttribute('data-door-inversion-title') || 'Door reversal fee';
      var priceEl = document.createElement('span');
      priceEl.className = 'cart-drawer__door-fee-price';
      priceEl.textContent = formatMoneyPlus(unitCents * (item.quantity || 1));
      row.appendChild(title);
      row.appendChild(priceEl);
      return row;
    }

    function refreshDrawer(cart) {
      var visibleCount = visibleCartCount(cart);
      /* Update count — skip Écofrais lines, they show as a price note. */
      if (countEl) countEl.textContent = visibleCount;
      if (headerBadge) {
        headerBadge.textContent = visibleCount;
        headerBadge.style.display = visibleCount > 0 ? '' : 'none';
      }
      /* Update subtotal */
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      /* Économie totale — la ligne existe dans le rendu serveur seulement si une
         remise s'appliquait au chargement. Elle doit donc pouvoir APPARAÎTRE et
         DISPARAÎTRE : ajouter un article remisé au panier ouvert crée le cas, en
         retirer le dernier l'annule. */
      var savingsEl = document.querySelector('[data-cart-savings]');
      if (savingsEl) {
        var amountEl = savingsEl.querySelector('[data-cart-savings-amount]');
        if (amountEl) amountEl.textContent = '\u2212' + formatMoney(cart.total_discount);
        savingsEl.style.display = cart.total_discount > 0 ? '' : 'none';
      }
      /* Show/hide footer */
      if (footerEl) footerEl.style.display = visibleCount > 0 ? '' : 'none';

      var emptyMsg = document.getElementById('cart-drawer-empty');

      if (visibleCount === 0) {
        var oldItems = document.getElementById('cart-drawer-items');
        if (oldItems) oldItems.remove();
        if (!emptyMsg) {
          var p = document.createElement('p');
          p.id = 'cart-drawer-empty';
          p.className = 'cart-drawer__empty';
          p.textContent = document.documentElement.lang === 'fr' ? 'Votre panier est vide' : 'Your cart is empty';
          bodyEl.appendChild(p);
        }
        return;
      }

      if (emptyMsg) emptyMsg.remove();

      /* Rebuild all items from cart JSON using safe DOM methods */
      var container = document.getElementById('cart-drawer-items');
      if (!container) {
        container = document.createElement('div');
        container.id = 'cart-drawer-items';
        container.className = 'cart-drawer__items';
        bodyEl.appendChild(container);
      }
      container.replaceChildren();
      var doorUnit = doorFeeUnitCents(cart);
      cart.items.forEach(function(item) {
        if (isEcofeeLine(item)) return;
        container.appendChild(createItemEl(item));
        var feeRow = createDoorFeeRow(item, doorUnit);
        if (feeRow) container.appendChild(feeRow);
      });
    }

    /* Delegate click events on cart items */
    drawer.addEventListener('click', function(e) {
      var minusBtn = e.target.closest('[data-cart-qty-minus]');
      var plusBtn = e.target.closest('[data-cart-qty-plus]');
      var removeBtn = e.target.closest('[data-cart-remove]');
      var upsellBtn = e.target.closest('[data-cart-upsell-add]');

      if (upsellBtn) {
        var variantId = upsellBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        upsellBtn.disabled = true;
        fetch('/cart/add.js?sections=cart-drawer', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
        .then(function(r) { return r.json(); })
        .then(function(json) {
          if (json.sections && json.sections['cart-drawer']) {
            refreshDrawerFromSection(json.sections['cart-drawer']);
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        })
        .catch(function() { upsellBtn.disabled = false; });
        return;
      }

      var accBtn = e.target.closest('[data-cart-accessory-add]');
      if (accBtn) {
        var accVariantId = accBtn.getAttribute('data-variant-id');
        if (!accVariantId) return;
        accBtn.disabled = true;
        fetch('/cart/add.js?sections=cart-drawer', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(accVariantId, 10), quantity: 1 }] })
        })
        .then(function(r) { return r.json(); })
        .then(function(json) {
          if (json.sections && json.sections['cart-drawer']) {
            refreshDrawerFromSection(json.sections['cart-drawer']);
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        })
        .catch(function() { accBtn.disabled = false; });
        return;
      }

      var accArrow = e.target.closest('[data-acc-prev], [data-acc-next]');
      if (accArrow) {
        var accTrack = drawer.querySelector('[data-cart-accessories-track]');
        if (accTrack) {
          var pw = accPageWidth(accTrack);
          var cur = Math.round(accTrack.scrollLeft / pw);
          slideTrackTo(accTrack, ((accArrow.hasAttribute('data-acc-next') ? cur + 1 : cur - 1)) * pw, 460);
          pauseAccessoryAuto();
        }
        return;
      }

      if (minusBtn) {
        var item = minusBtn.closest('[data-cart-item]');
        var qty = parseInt(item.querySelector('[data-cart-qty-value]').textContent, 10);
        queueQty(item, Math.max(0, qty - 1));
      } else if (plusBtn) {
        var item2 = plusBtn.closest('[data-cart-item]');
        var qty2 = parseInt(item2.querySelector('[data-cart-qty-value]').textContent, 10);
        queueQty(item2, qty2 + 1);
      } else if (removeBtn) {
        var item3 = removeBtn.closest('[data-cart-item]');
        removeItemWithProtection(item3);
      }
    });

    /* Open the drawer the instant the user clicks "Ajouter au panier" — the
       PDP form dispatches this before the network round-trip starts. Avoids
       a perceived 300–600 ms delay where the user thinks the click did
       nothing. Also flags the body as loading so a spinner overlay shows
       while the SRA fetch is in flight; the class is auto-dropped when
       refreshDrawerFromSection replaces the body element. */
    document.addEventListener('cart:open-instant', function() {
      open();
      var body = document.getElementById('cart-drawer-body');
      if (body) body.classList.add('is-loading');
    });

    /* After a successful add/update, re-render the drawer from the
       Section Rendering API (one round-trip; metafields-aware Liquid).
       The PDP add path already passes pre-fetched section HTML via
       event.detail to skip this fetch entirely. */
    document.addEventListener('cart:updated', function(e) {
      var silent = e && e.detail && e.detail.silent;
      if (e && e.detail && e.detail.sectionHtml) {
        refreshDrawerFromSection(e.detail.sectionHtml);
        if (!silent) open();
        return;
      }
      // Re-render from the current language's root (/en/ on English pages):
      // plain '/' is the French homepage, so English pages flashed a French
      // drawer until the next refresh.
      var drawerRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(drawerRoot + '?sections=cart-drawer')
        .then(function(r) { return r.json(); })
        .then(function(json) {
          if (json && json['cart-drawer']) {
            refreshDrawerFromSection(json['cart-drawer']);
          }
          if (!silent) open();
        });
    });

    /* Custom eased slide — smoother and more consistent than native
       behavior:'smooth'. Scroll-snap is briefly turned off so it doesn't fight
       the tween, then restored to land cleanly on a column. */
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var accTween = null;
    function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function cancelAccTween(track) {
      if (accTween) { cancelAnimationFrame(accTween); accTween = null; }
      if (track) track.style.scrollSnapType = '';
    }
    function slideTrackTo(track, to, duration) {
      to = Math.max(0, Math.min(to, track.scrollWidth - track.clientWidth));
      cancelAccTween(track);
      var start = track.scrollLeft;
      var change = to - start;
      if (Math.abs(change) < 1) return;
      if (prefersReducedMotion || duration <= 0) { track.scrollLeft = to; return; }
      track.style.scrollSnapType = 'none';
      var startTime = null;
      function step(ts) {
        if (startTime === null) startTime = ts;
        var t = Math.min(1, (ts - startTime) / duration);
        track.scrollLeft = start + change * easeInOutCubic(t);
        if (t < 1) {
          accTween = requestAnimationFrame(step);
        } else {
          track.scrollLeft = to;
          track.style.scrollSnapType = '';
          accTween = null;
        }
      }
      accTween = requestAnimationFrame(step);
    }
    function accPageWidth(track) { return track.clientWidth + 8; }

    /* Auto-advance: gently page the carousel and loop at the end. Pauses while
       closed, on hover, on reduced-motion, or after the user interacts. */
    var accAutoPausedUntil = 0;
    function pauseAccessoryAuto() { accAutoPausedUntil = Date.now() + 7000; }
    function accessoryAutoTick() {
      if (prefersReducedMotion) return;
      var track = drawer.querySelector('[data-cart-accessories-track]');
      if (!track) return;
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      if (Date.now() < accAutoPausedUntil) return;
      if (track.matches(':hover')) return;
      var pw = accPageWidth(track);
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 4) return;
      var cur = Math.round(track.scrollLeft / pw);
      var next = (cur + 1) * pw;
      if (next > maxScroll - 4) next = 0;
      slideTrackTo(track, next, 650);
    }
    setInterval(accessoryAutoTick, 4500);

    /* Pause auto-advance + cancel any tween while the user swipes by hand. */
    drawer.addEventListener('pointerdown', function(e) {
      if (e.target.closest('[data-cart-accessories-track]')) {
        pauseAccessoryAuto();
        cancelAccTween(drawer.querySelector('[data-cart-accessories-track]'));
      }
    });

    /* Show the slider arrows only when there's more than one page to scroll. */
    function updateAccessoryNav() {
      var track = drawer.querySelector('[data-cart-accessories-track]');
      var nav = drawer.querySelector('[data-cart-accessories-nav]');
      if (!track || !nav) return;
      nav.style.display = (track.scrollWidth - track.clientWidth > 4) ? 'flex' : 'none';
    }
    updateAccessoryNav();
    window.addEventListener('resize', updateAccessoryNav);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'vp_cookie_consent';
    var VERSION = 1;

    var el = document.getElementById('cookie-consent');
    if (!el) return;
    var reopenBtn = document.querySelector('[data-cc-reopen]');

    function load() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function persist(consent) {
      consent.necessary = true;
      consent.v = VERSION;
      consent.t = new Date().toISOString();
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
      } catch (e) {}
    }

    // Push the decision to Shopify so every pixel managed through Shopify
    // (analytics, marketing, custom web pixels) respects it.
    function applyToShopify(consent) {
      var payload = {
        analytics: !!consent.analytics,
        marketing: !!consent.marketing,
        preferences: !!consent.preferences,
        sale_of_data: !!consent.marketing
      };
      function setConsent() {
        try {
          if (window.Shopify && window.Shopify.customerPrivacy &&
              typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
            window.Shopify.customerPrivacy.setTrackingConsent(payload, function () {});
          }
        } catch (e) {}
      }
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (err) { if (!err) setConsent(); }
        );
      } else {
        setConsent();
      }
    }

    function apply(consent) {
      applyToShopify(consent);
      document.dispatchEvent(new CustomEvent('cookie-consent:updated', { detail: consent }));
    }

    function setView(view) {
      var views = el.querySelectorAll('[data-view]');
      for (var i = 0; i < views.length; i++) {
        views[i].hidden = views[i].getAttribute('data-view') !== view;
      }
    }

    function show(view) {
      setView(view || 'main');
      el.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () { el.classList.add('is-visible'); });
    }

    function hide() {
      el.classList.remove('is-visible');
      el.setAttribute('aria-hidden', 'true');
    }

    function showReopen() {
      if (!reopenBtn) return;
      reopenBtn.setAttribute('aria-hidden', 'false');
      reopenBtn.classList.add('is-visible');
    }

    function syncToggles(consent) {
      consent = consent || {};
      var inputs = el.querySelectorAll('[data-cc-category]');
      for (var i = 0; i < inputs.length; i++) {
        var cat = inputs[i].getAttribute('data-cc-category');
        if (cat === 'necessary') continue;
        inputs[i].checked = !!consent[cat];
      }
    }

    function readToggles() {
      var consent = { necessary: true };
      var inputs = el.querySelectorAll('[data-cc-category]');
      for (var i = 0; i < inputs.length; i++) {
        var cat = inputs[i].getAttribute('data-cc-category');
        if (cat === 'necessary') continue;
        consent[cat] = inputs[i].checked;
      }
      return consent;
    }

    function commit(consent) {
      persist(consent);
      apply(consent);
      hide();
      showReopen();
    }

    el.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn || !el.contains(btn)) return;

      if (btn.hasAttribute('data-cc-accept')) {
        commit({ analytics: true, marketing: true, preferences: true });
      } else if (btn.hasAttribute('data-cc-refuse')) {
        commit({ analytics: false, marketing: false, preferences: false });
      } else if (btn.hasAttribute('data-cc-customize')) {
        syncToggles(load());
        setView('prefs');
      } else if (btn.hasAttribute('data-cc-back')) {
        setView('main');
      } else if (btn.hasAttribute('data-cc-save')) {
        commit(readToggles());
      }
    });

    if (reopenBtn) {
      reopenBtn.addEventListener('click', function () {
        syncToggles(load());
        show('main');
      });
    }

    // Any element (e.g. a footer link) can reopen the panel to withdraw consent.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cookie-preferences]');
      if (!trigger) return;
      e.preventDefault();
      syncToggles(load());
      show('prefs');
    });

    // Escape dismisses only once a choice already exists.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-visible') && load()) hide();
    });

    var existing = load();
    if (existing && existing.v === VERSION) {
      apply(existing);
      showReopen();
    } else {
      // Opt-in everywhere: withhold non-essential tracking until the visitor
      // chooses, so Shopify honours the decision even in regions where its
      // default would otherwise be to allow all processing.
      applyToShopify({ analytics: false, marketing: false, preferences: false });
      show('main');
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["included-bundle-components"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.vpBundleComponentAddBound) return;
    window.vpBundleComponentAddBound = true;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-bundle-component-form')) return;
      event.preventDefault();

      var idInput = form.querySelector('input[name="id"]');
      var variantId = idInput && idInput.value;
      var button = form.querySelector('button[type="submit"]');
      if (!variantId) return;
      if (button) button.disabled = true;

      document.dispatchEvent(new CustomEvent('cart:open-instant'));
      fetch('/cart/add.js?sections=cart-drawer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (response) {
          return response.json().then(function (json) {
            return { ok: response.ok, json: json };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            if (button) button.disabled = false;
            return;
          }
          var sectionHtml = result.json && result.json.sections && result.json.sections['cart-drawer'];
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: sectionHtml ? { sectionHtml: sectionHtml } : null
          }));
          if (button) button.disabled = false;
        })
        .catch(function () {
          if (button) button.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["linked-products"] && !Shopify.designMode) return;
  try {
    (function () {
    var container = document.querySelector('[data-linked-products]');
    if (!container) return;
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;

    // The gallery main container opens the lightbox on click; pill clicks
    // (navigation) must not bubble into it.
    container.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    var chips = container.querySelectorAll('[data-linked-chip]');
    if (!chips.length) return;

    var overlay = document.createElement('div');
    overlay.className = 'linked-products__preview';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<img class="linked-products__preview-image" alt="">' +
      '<div class="linked-products__preview-caption">' +
      '<span class="linked-products__preview-label"></span>' +
      '<span class="linked-products__preview-price"></span>' +
      '</div>';
    main.appendChild(overlay);

    var img = overlay.querySelector('.linked-products__preview-image');
    var label = overlay.querySelector('.linked-products__preview-label');
    var price = overlay.querySelector('.linked-products__preview-price');

    chips.forEach(function (chip) {
      var src = chip.getAttribute('data-preview-src');
      if (!src) return;

      // Warm the cache so the first hover doesn't flash an empty frame
      var preload = new Image();
      preload.src = src;

      function show() {
        img.src = src;
        label.textContent = chip.getAttribute('data-preview-label') || '';
        price.textContent = chip.getAttribute('data-preview-price') || '';
        overlay.classList.add('is-visible');
      }
      function hide() {
        overlay.classList.remove('is-visible');
      }

      chip.addEventListener('mouseenter', show);
      chip.addEventListener('mouseleave', hide);
      chip.addEventListener('focus', show);
      chip.addEventListener('blur', hide);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mode-toggle"] && !Shopify.designMode) return;
  try {
    // Toggle the mode class on <html>+<body>. CSS derives the active pill from
  // those classes (see :where(html, body).mode--… selectors above), so there's
  // no per-button class to manage. localStorage persists across navigations.
  document.querySelectorAll('[data-mode-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var mode = this.dataset.modeToggle;
      var root = document.documentElement;
      root.classList.remove('mode--conservation', 'mode--degustation');
      root.classList.add('mode--' + mode);
      document.body.classList.remove('mode--conservation', 'mode--degustation');
      document.body.classList.add('mode--' + mode);
      localStorage.setItem('vp-mode', mode);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function() {
    var container = document.getElementById('header-search');
    var searchArea = document.getElementById('header-search-area');
    var input = document.getElementById('header-search-input');
    var closeBtn = document.getElementById('header-search-close');
    var dropdown = document.getElementById('header-search-dropdown');
    var resultsEl = document.getElementById('header-search-results');
    var emptyEl = document.getElementById('header-search-empty');
    if (!container || !input) return;

    var debounceTimer;
    var isLocked = false; /* Keep open when typing */
    var searchUrl = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var viewAllLabel = document.documentElement.lang === 'fr' ? 'Voir tous les produits \u203A' : 'View all products \u203A';

    /* When the typed term exactly matches a collection name, Enter and the
       "view all" link go to that collection instead of /search results. */
    var collectionMap = {};
    try {
      var mapEl = document.getElementById('header-search-collection-map');
      if (mapEl) collectionMap = JSON.parse(mapEl.textContent || '{}');
    } catch (e) { collectionMap = {}; }

    function collectionUrlFor(query) {
      if (!query) return null;
      var key = query.toLowerCase().trim();
      return Object.prototype.hasOwnProperty.call(collectionMap, key) ? collectionMap[key] : null;
    }

    /* Intercept Enter / form submit: redirect to the matching collection. */
    if (input.form) {
      input.form.addEventListener('submit', function(e) {
        var url = collectionUrlFor(input.value);
        if (url) {
          e.preventDefault();
          window.location.href = url;
        }
      });
    }

    /* Expand-on-hover only on hover-capable devices AT desktop widths;
       touch devices and mobile-sized viewports open on tap instead
       (emulated mouseenter on first tap is unreliable and surprising).
       Evaluated at event time so resizing a window switches behavior. */
    function useHover() {
      if (!window.matchMedia) return true;
      return window.matchMedia('(hover: hover)').matches &&
        window.matchMedia('(min-width: 769px)').matches;
    }

    function open() {
      container.classList.add('is-open');
      if (useHover()) {
        setTimeout(function() { input.focus(); }, 300);
      } else {
        /* Focus synchronously within the tap gesture so iOS opens the keyboard */
        input.focus();
      }
    }

    function close() {
      if (isLocked) return;
      container.classList.remove('is-open');
      input.value = '';
      input.blur();
      while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
      emptyEl.style.display = 'none';
      dropdown.classList.remove('is-visible');
    }

    function forceClose() {
      isLocked = false;
      container.classList.remove('is-open');
      input.value = '';
      input.blur();
      while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
      emptyEl.style.display = 'none';
      dropdown.classList.remove('is-visible');
    }

    function el(tag, cls, attrs) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (attrs) Object.keys(attrs).forEach(function(k) { node.setAttribute(k, attrs[k]); });
      return node;
    }

    /* Click/tap on the icon expands — the primary interaction on touch,
       and a nice affordance with a mouse too */
    var searchIcon = searchArea.querySelector('.header-search__icon');
    if (searchIcon) {
      searchIcon.addEventListener('click', function() {
        if (!container.classList.contains('is-open')) open();
      });
    }

    /* Hover to expand (like SimpleSearch desktop) */
    searchArea.addEventListener('mouseenter', function() {
      if (useHover() && !container.classList.contains('is-open')) open();
    });

    /* Mouse leave to collapse — only if no query and input not focused */
    container.addEventListener('mouseleave', function() {
      if (useHover() && !input.value.trim() && document.activeElement !== input) {
        close();
      }
    });

    /* Lock open when user starts typing */
    input.addEventListener('input', function() {
      if (input.value.trim()) {
        isLocked = true;
      } else {
        isLocked = false;
      }

      clearTimeout(debounceTimer);
      var q = input.value.trim();
      if (q.length < 2) {
        while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
        emptyEl.style.display = 'none';
        dropdown.classList.remove('is-visible');
        return;
      }
      debounceTimer = setTimeout(function() { fetchResults(q); }, 250);
    });

    /* Blur: collapse if no query */
    input.addEventListener('blur', function() {
      setTimeout(function() {
        if (!input.value.trim() && !container.matches(':hover')) {
          isLocked = false;
          close();
        }
      }, 150);
    });

    /* Close button */
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      forceClose();
    });

    /* Click outside */
    document.addEventListener('mousedown', function(e) {
      if (container.classList.contains('is-open') && !container.contains(e.target)) {
        forceClose();
      }
    });

    /* Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && container.classList.contains('is-open')) forceClose();
    });

    function fetchResults(query) {
      // resources[options][fields] is defensive — predictive search includes
      // variants.sku/barcode by default, but listing them explicitly insulates
      // us if Shopify changes defaults. Mirrors the hidden inputs on the form.
      // Products only — pages/articles excluded from storefront search.
      var url = searchUrl + 'search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=5' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,vendor,product_type,tag,variants.sku,variants.barcode,body';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(data) { renderResults(data, query); });
    }

    function renderResults(data, query) {
      while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
      var resources = data.resources && data.resources.results;
      if (!resources) return;

      var hasResults = false;
      var products = resources.products || [];
      if (products.length > 0) {
        hasResults = true;
        var group = el('div', 'header-search__group');
        var list = el('div', 'header-search__products');
        products.forEach(function(p) {
          var link = el('a', 'header-search__product', { href: p.url });

          var imgWrap = el('div', 'header-search__product-image');
          if (p.image) {
            var img = el('img');
            img.src = p.image.replace(/(\.[^.]+)$/, '_120x120$1');
            img.alt = '';
            img.loading = 'lazy';
            imgWrap.appendChild(img);
          }
          link.appendChild(imgWrap);

          var info = el('div', 'header-search__product-info');
          if (p.vendor) {
            var vendor = el('div', 'header-search__product-vendor');
            vendor.textContent = p.vendor;
            info.appendChild(vendor);
          }
          var title = el('div', 'header-search__product-title');
          title.textContent = p.title;
          info.appendChild(title);
          link.appendChild(info);

          list.appendChild(link);
        });
        group.appendChild(list);
        resultsEl.appendChild(group);
      }

      // If the term exactly matches a collection name, "view all" leads to
      // that collection; otherwise to the /search page (products only + SKU fields).
      var collectionUrl = collectionUrlFor(query);
      var showAny = hasResults || !!collectionUrl;
      if (showAny) {
        var viewAllUrl = collectionUrl || (searchUrl + 'search?q=' + encodeURIComponent(query) +
          '&type=product' +
          '&options%5Bprefix%5D=last' +
          '&options%5Bfields%5D=title%2Cvendor%2Cproduct_type%2Ctag%2Cvariants.sku%2Cvariants.barcode%2Cbody');
        var viewAll = el('a', 'header-search__view-all', { href: viewAllUrl });
        viewAll.textContent = viewAllLabel;
        resultsEl.appendChild(viewAll);
      }

      dropdown.classList.toggle('is-visible', showAny || input.value.trim().length >= 2);
      emptyEl.style.display = showAny ? 'none' : 'block';
    }
  })();

  /* Account dropdown: click toggles, click outside or Esc closes. */
  (function() {
    var wrapper = document.querySelector('[data-account-wrapper]');
    if (!wrapper) return;
    var toggle = wrapper.querySelector('[data-account-toggle]');
    var menu = wrapper.querySelector('[data-account-menu]');
    if (!toggle || !menu) return;

    function setOpen(open) {
      if (open) {
        menu.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }
    }

    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(menu.hidden);
    });

    document.addEventListener('click', function(e) {
      if (!menu.hidden && !wrapper.contains(e.target)) setOpen(false);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !menu.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buybar"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-vp-buybar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var actions = document.querySelector('.product-hero__info .product-form__actions');
    var real = actions && actions.querySelector('button[type="submit"]');
    var add = bar.querySelector('[data-buybar-add]');
    var price = bar.querySelector('[data-buybar-price]');
    if (!real || !add) return;

    var compare = bar.querySelector('[data-buybar-compare]');
    var ecofee = bar.querySelector('[data-buybar-ecofee]');
    var model = bar.querySelector('[data-buybar-model]');
    var sku = bar.querySelector('[data-buybar-sku]');
    var mirror = function (target, source) {
      var text = source ? source.textContent.trim() : '';
      target.textContent = text;
      target.hidden = !text;
    };

    // Mirror the buy box: price (regular price struck through when on sale), eco-fee,
    // model number (it follows the chosen variant) and the button's label and state.
    var sync = function () {
      var current = document.querySelector('.product-hero__price .product-hero__price-current');
      if (current && price) {
        price.textContent = current.textContent.trim();
        price.classList.toggle('is-sale', current.classList.contains('product-hero__price-current--sale'));
      }
      mirror(compare, document.querySelector('.product-hero__price .product-hero__price-compare'));
      mirror(ecofee, document.querySelector('.product-hero__pricing .ecofee-note'));
      var heroSku = document.querySelector('[data-hero-sku]');
      sku.textContent = heroSku ? heroSku.textContent.trim() : '';
      model.hidden = !sku.textContent;
      add.disabled = real.disabled;
      add.textContent = real.textContent.trim();
    };
    sync();
    var watch = new MutationObserver(sync);
    watch.observe(real, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    ['.product-hero__pricing', '[data-hero-sku]'].forEach(function (sel) {
      var box = document.querySelector(sel);
      if (box) watch.observe(box, { childList: true, characterData: true, subtree: true });
    });

    var root = document.documentElement;
    // How far the chat and cookie buttons move up: the bar when it shows, plus Shopify's
    // preview banner during theme previews (else they drop behind it when the bar hides).
    var offset = function () {
      var banner = parseInt(bar.style.bottom, 10) || 0;
      var up = (bar.classList.contains('is-visible') ? bar.offsetHeight : 0) + banner;
      root.style.setProperty('--vp-buybar-offset', up + 'px');
      root.classList.toggle('vp-buybar-on', up > 0);
    };
    var show = function (on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      add.tabIndex = on ? 0 : -1;
      offset();
    };
    // The bar stays until the buy box's buttons are fully on screen above it: a sliver of
    // them peeking at the bottom edge is not enough to buy from.
    var watchButtons = function () {
      var io = new IntersectionObserver(function (entries) {
        show(entries[0].intersectionRatio < 0.99);
      }, { threshold: [0, 0.5, 0.99, 1], rootMargin: '0px 0px -' + (bar.offsetHeight || 80) + 'px 0px' });
      io.observe(actions);
      return io;
    };
    watchButtons();

    add.addEventListener('click', function () {
      if (!add.disabled) real.click();
    });

    // Theme previews only: Shopify's preview banner is fixed to the same bottom edge, so
    // the bar sits just above it (it arrives late and can be hidden, hence the polling).
    var lift = function () {
      var pbar = document.getElementById('PBarNextFrameWrapper');
      var r = pbar ? pbar.getBoundingClientRect() : null;
      // Only the full banner counts: once hidden (« Hide bar ») a small tab remains, which
      // must not leave a gap under the bar.
      var h = r && r.height >= 40 && r.bottom >= window.innerHeight - 2 ? Math.round(r.height) : 0;
      bar.style.bottom = h > 0 ? h + 'px' : '';
      offset();
    };
    var polls = 0;
    var poll = setInterval(function () {
      lift();
      if (++polls > 20) clearInterval(poll);
    }, 500);
    window.addEventListener('resize', lift);
    document.addEventListener('click', function () { setTimeout(lift, 300); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    (function() {
    /* Quantity buttons */
    document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.closest('.product-form__qty-control').querySelector('[data-qty-input]');
        var val = parseInt(input.value, 10);
        if (val > 1) input.value = val - 1;
      });
    });

    document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.closest('.product-form__qty-control').querySelector('[data-qty-input]');
        input.value = parseInt(input.value, 10) + 1;
      });
    });

    /* Update button state based on selected variant availability */
    function updateButtonState(form, available) {
      var submit = form.querySelector('.product-form__submit');
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available
          ? submit.getAttribute('data-add-text')
          : submit.getAttribute('data-sold-text');
      }
    }

    /* Sync gallery image + hero price when the selected variant changes */
    function applyVariantOption(select, option) {
      if (!option) return;
      var available = option.getAttribute('data-variant-available') === 'true';
      var form = select.closest('.product-form');
      if (form) updateButtonState(form, available);

      // Gallery: jump to the image linked to this variant (if any)
      var imageId = option.getAttribute('data-variant-image-id');
      if (imageId) {
        var hero = select.closest('.product-hero') || document;
        var gallery = hero.querySelector('[data-product-gallery]') || document.querySelector('[data-product-gallery]');
        if (gallery) {
          gallery.dispatchEvent(new CustomEvent('variant:image', {
            detail: { imageId: imageId },
            bubbles: true
          }));
        }
      }

      // Hero price display
      var priceHtml = option.getAttribute('data-variant-price');
      var compareHtml = option.getAttribute('data-variant-compare');
      var scope = select.closest('.product-hero') || document;

      // Livraison card: Gratuite once this variant already clears the
      // free-shipping threshold (Petit Stock = 99 $). Under the threshold
      // keep "À partir de 14,95 $" + "Gratuite dès commande de 99 $".
      var shipLine = scope.querySelector('[data-ship-line]');
      var shipSub = scope.querySelector('[data-ship-sub]');
      if (shipLine && shipLine.getAttribute('data-ship-threshold')) {
        var variantCents = parseInt(option.getAttribute('data-variant-price-cents'), 10);
        var thresholdCents = parseInt(shipLine.getAttribute('data-ship-threshold'), 10);
        var qualifies = !isNaN(variantCents) && !isNaN(thresholdCents) && variantCents >= thresholdCents;
        var freeCopy = shipLine.getAttribute('data-ship-free');
        var fromCopy = shipLine.getAttribute('data-ship-from');
        if (qualifies && freeCopy) shipLine.textContent = freeCopy;
        else if (fromCopy) shipLine.textContent = fromCopy;
        if (shipSub) shipSub.hidden = qualifies;
      }
      var priceWrap = scope.querySelector('.product-hero__price');
      if (priceWrap && priceHtml) {
        var current = priceWrap.querySelector('.product-hero__price-current');
        var compare = priceWrap.querySelector('.product-hero__price-compare');
        if (current) {
          current.textContent = priceHtml;
          current.classList.toggle('product-hero__price-current--sale', !!compareHtml);
        }
        if (compareHtml) {
          if (!compare) {
            compare = document.createElement('span');
            compare.className = 'product-hero__price-compare';
            current.insertAdjacentElement('afterend', compare);
          }
          compare.textContent = compareHtml;
          compare.hidden = false;
        } else if (compare) {
          compare.hidden = true;
          compare.textContent = '';
        }
      }

      var sku = option.getAttribute('data-sku');
      var skuEl = scope.querySelector('[data-hero-sku][data-sku-follows-variant]');
      if (skuEl && sku) skuEl.textContent = sku;

      // Keep the URL in sync so refresh/share lands on the same variant
      if (option.value && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url.toString());
        } catch (err) { /* ignore */ }
      }
    }

    document.querySelectorAll('[data-variant-select]').forEach(function(select) {
      select.addEventListener('change', function() {
        applyVariantOption(this, this.options[this.selectedIndex]);
      });
      // On load: if a variant is pre-selected (e.g. ?variant=), show its image
      if (select.selectedIndex >= 0) {
        applyVariantOption(select, select.options[select.selectedIndex]);
      }
    });

    /* Langue FR/EN: the locale form keeps ?variant= from the previous
       language, so Liquid may still have Français selected on an EN page.
       Remap unless the customer explicitly chose Chinois. */
    if (document.querySelector('[data-sku-follows-variant]')) {
      var pageLang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
      function vpNormLang(s) {
        return String(s || '').toLowerCase().replace(/[éèê]/g, 'e').replace(/ç/g, 'c').trim();
      }
      function vpLangPref(n) {
        if (pageLang === 'en') return n === 'english' || n === 'anglais' || n === 'en';
        return n === 'francais' || n === 'french' || n === 'fr';
      }
      function vpLangOther(n) {
        return n === 'chinois' || n === 'chinese' || n === 'ch';
      }
      document.querySelectorAll('.product-hero__variant-option').forEach(function(optWrap) {
        var labelEl = optWrap.querySelector('.product-hero__variant-label');
        if (!labelEl) return;
        var optName = (labelEl.textContent || '').trim().toLowerCase();
        if (optName !== 'langue' && optName !== 'language' && optName !== 'lang') return;
        var buttons = optWrap.querySelectorAll('.product-form__option-btn');
        var active = optWrap.querySelector('.product-form__option-btn--active');
        if (active && vpLangOther(vpNormLang(active.getAttribute('data-option-value')))) return;
        var preferred = null;
        buttons.forEach(function(btn) {
          if (vpLangPref(vpNormLang(btn.getAttribute('data-option-value')))) preferred = btn;
        });
        if (!preferred || preferred === active) return;
        var container = preferred.closest('.product-hero__variant-values');
        if (container) {
          container.querySelectorAll('.product-form__option-btn').forEach(function(b) {
            b.classList.remove('product-form__option-btn--active');
          });
        }
        preferred.classList.add('product-form__option-btn--active');
        var hero = preferred.closest('.product-hero__info') || preferred.closest('.product-hero');
        var select = hero ? hero.querySelector('[data-variant-select]') : document.querySelector('[data-variant-select]');
        if (!select) return;
        var selectedOptions = [];
        (hero || document).querySelectorAll('.product-hero__variant-values').forEach(function(group) {
          var a = group.querySelector('.product-form__option-btn--active');
          if (a) selectedOptions.push(a.getAttribute('data-option-value'));
        });
        var selectedStr = selectedOptions.join('|');
        var options = select.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var optStr = options[i].getAttribute('data-variant-options');
          if (optStr && optStr.indexOf(selectedStr) === 0) {
            select.value = options[i].value;
            applyVariantOption(select, options[i]);
            break;
          }
        }
      });
    }

    /* O-1710 — same rules as vp-app/extensions/cart-transform-bundles/src/engraving.js */
    var ENGRAVING_UNIT_CENTS = 1500;
    function billedEngravingChars(text) {
      if (typeof text !== 'string') return 0;
      if (text.length < 2 || text.length > 6) return 0;
      if (!/^[A-Za-z0-9.\- ]+$/.test(text)) return 0;
      var billed = 0;
      for (var i = 0; i < text.length; i++) {
        if (text.charAt(i) !== ' ') billed += 1;
      }
      return billed;
    }
    function parseEngraving(raw) {
      var filtered = String(raw || '').replace(/[^A-Za-z0-9.\- ]/g, '').slice(0, 6);
      var trimmed = filtered.replace(/^\s+|\s+$/g, '');
      if (!trimmed) return { text: '', billed: 0, error: null };
      if (filtered.length === 1 || billedEngravingChars(filtered) === 0) {
        return { text: filtered, billed: 0, error: 'too_short' };
      }
      return { text: filtered, billed: billedEngravingChars(filtered), error: null };
    }
    function formatCad(cents) {
      var dollars = (cents / 100).toFixed(2);
      if (document.documentElement.lang === 'fr') return dollars.replace('.', ',') + ' $';
      return '$' + dollars;
    }
    function engravingFeeLabel(amount) {
      var node = document.querySelector('[data-engraving-fee-template]');
      var tpl = (node && node.getAttribute('data-engraving-fee-template')) || '+ PLACEHOLDER';
      return tpl.replace('PLACEHOLDER', amount);
    }

    function syncEngravingUi(form, parsed) {
      var scope = form.closest('.product-hero') || document;
      var wrap = form.querySelector('[data-engraving]');
      var fees = scope.querySelectorAll('[data-engraving-fee]');
      var err = form.querySelector('[data-engraving-error]');
      var input = form.querySelector('[data-engraving-input]');
      var count = form.querySelector('[data-engraving-count]');
      var hintIdle = form.querySelector('[data-engraving-hint-idle]');
      var hintLead = form.querySelector('[data-engraving-lead]');
      if (wrap) {
        wrap.classList.toggle('is-active', parsed.billed > 0);
        wrap.classList.toggle('is-invalid', !!parsed.error);
      }
      if (input) input.classList.toggle('is-invalid', !!parsed.error);
      if (count && input) count.textContent = input.value.length + '/6';
      if (err) {
        err.textContent = parsed.error === 'too_short'
          ? (err.getAttribute('data-too-short') || '')
          : '';
        err.classList.toggle('is-on', parsed.error === 'too_short');
      }
      if (hintIdle) hintIdle.classList.toggle('is-on', parsed.billed <= 0 && !parsed.error);
      if (hintLead) hintLead.classList.toggle('is-on', parsed.billed > 0 && !parsed.error);
      var feeLabel = parsed.billed > 0
        ? engravingFeeLabel(formatCad(parsed.billed * ENGRAVING_UNIT_CENTS))
        : '\u00a0';
      fees.forEach(function(fee) {
        fee.classList.toggle('is-on', parsed.billed > 0);
        fee.textContent = feeLabel;
        fee.setAttribute('aria-hidden', parsed.billed > 0 ? 'false' : 'true');
      });
    }

    document.querySelectorAll('[data-engraving]').forEach(function(wrap) {
      var form = wrap.closest('.product-form');
      var input = wrap.querySelector('[data-engraving-input]');
      var err = wrap.querySelector('[data-engraving-error]');
      if (err) {
        err.setAttribute('data-too-short', wrap.getAttribute('data-error-too-short') || '');
      }
      if (!input || !form) return;
      input.addEventListener('input', function() {
        var next = input.value.replace(/[^A-Za-z0-9.\- ]/g, '').slice(0, 6);
        if (next !== input.value) input.value = next;
        syncEngravingUi(form, parseEngraving(input.value));
      });
    });

    /* AJAX add-to-cart — intercept form submit. When the optional protection
       toggle (rendered in product-hero, outside this form) is ON, add the
       linked plan variant alongside the main item in a single /cart/add.js
       request via the items[] array. */
    document.querySelectorAll('.product-form').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(form);
        var engravingInput = form.querySelector('[data-engraving-input]');
        if (engravingInput) {
          var parsed = parseEngraving(engravingInput.value);
          if (parsed.error) {
            syncEngravingUi(form, parsed);
            engravingInput.focus();
            return;
          }
          if (!parsed.text) formData.delete('properties[Gravure]');
          else formData.set('properties[Gravure]', parsed.text);
        }
        // Open drawer immediately for instant feedback — content fills in when
        // /cart/add.js + /cart.js complete a few hundred ms later.
        document.dispatchEvent(new CustomEvent('cart:open-instant'));
        var scope = form.closest('.product-hero') || document;
        var toggle = scope.querySelector('[data-protection-toggle]');
        var planVariantId = toggle ? toggle.getAttribute('data-protection-variant') : null;
        var toggleActive = toggle && toggle.getAttribute('data-warranty-active') === 'true';
        var fetchOpts;
        var gravure = formData.get('properties[Gravure]');
        var lineProperties = gravure ? { Gravure: gravure } : undefined;
        var mainId = formData.get('id');
        var mainQty = parseInt(formData.get('quantity'), 10) || 1;
        var ecofeeId = window.vpEcofeeVariantId
          ? window.vpEcofeeVariantId(
              form.getAttribute('data-product-type') ||
              (form.closest('[data-product-type]') && form.closest('[data-product-type]').getAttribute('data-product-type'))
            )
          : null;
        var extraItems = [];
        if (toggleActive && planVariantId) extraItems.push({ id: planVariantId, quantity: 1 });
        if (ecofeeId) extraItems.push({ id: ecofeeId, quantity: mainQty });
        var doorId = window.vpDoorInversionVariantId ? window.vpDoorInversionVariantId() : null;
        var doorWrap = form.closest('[data-door-pair]');
        var doorPair = (doorWrap && doorWrap.getAttribute('data-door-pair') === 'true')
          || form.getAttribute('data-door-pair') === 'true';
        var selectedSku = '';
        var variantSelect = form.querySelector('[data-variant-select]');
        if (variantSelect && variantSelect.selectedIndex >= 0) {
          selectedSku = variantSelect.options[variantSelect.selectedIndex].getAttribute('data-sku') || '';
        } else {
          var hiddenId = form.querySelector('input[name="id"]');
          selectedSku = hiddenId ? (hiddenId.getAttribute('data-sku') || '') : '';
        }
        var skuIsPg = typeof window.vpSkuEndsPg === 'function'
          ? window.vpSkuEndsPg(selectedSku)
          : /(?:-PG)$/i.test(String(selectedSku).trim());
        if (doorId && doorPair && skuIsPg) extraItems.push({ id: doorId, quantity: mainQty });
        // Free gift of a « buy X get Y » (gift-cart.liquid): same request, so the
        // drawer opens with the gift already in it.
        var giftWrap = form.closest('[data-product-id]');
        if (window.vpGiftItems && giftWrap) {
          extraItems = extraItems.concat(window.vpGiftItems(giftWrap.getAttribute('data-product-id'), mainQty));
        }

        if (extraItems.length) {
          var mainItem = { id: mainId, quantity: mainQty };
          if (lineProperties) mainItem.properties = lineProperties;
          fetchOpts = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [mainItem].concat(extraItems) })
          };
        } else {
          fetchOpts = { method: 'POST', body: formData };
        }

        fetch('/cart/add.js?sections=cart-drawer', fetchOpts)
          .then(function(r) { return r.json(); })
          .then(function(json) {
            var sectionHtml = json && json.sections && json.sections['cart-drawer'];
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: sectionHtml ? { sectionHtml: sectionHtml } : null
            }));
          });
      });
    });

    /* Variant option buttons (may live outside this snippet, in product-hero) */
    function hideDoorPopups() {
      document.querySelectorAll('[data-door-pg-popup]').forEach(function(p) {
        p.hidden = true;
      });
    }

    document.querySelectorAll('.product-form__option-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var container = this.closest('.product-hero__variant-values');
        if (!container) return;
        container.querySelectorAll('.product-form__option-btn').forEach(function(b) {
          b.classList.remove('product-form__option-btn--active');
        });
        this.classList.add('product-form__option-btn--active');

        hideDoorPopups();
        if (this.hasAttribute('data-door-pg')) {
          var wrap = this.closest('[data-door-pg-wrap]');
          var popup = wrap && wrap.querySelector('[data-door-pg-popup]');
          if (popup) {
            popup.hidden = false;
            e.stopPropagation();
          }
        }

        /* Build selected options and find matching variant */
        var hero = this.closest('.product-hero__info') || this.closest('.product-hero');
        var select = hero ? hero.querySelector('[data-variant-select]') : document.querySelector('[data-variant-select]');
        if (!select) return;

        var selectedOptions = [];
        (hero || document).querySelectorAll('.product-hero__variant-values').forEach(function(group) {
          var active = group.querySelector('.product-form__option-btn--active');
          if (active) selectedOptions.push(active.getAttribute('data-option-value'));
        });

        var selectedStr = selectedOptions.join('|');
        var options = select.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var optStr = options[i].getAttribute('data-variant-options');
          if (optStr && optStr.indexOf(selectedStr) === 0) {
            select.value = options[i].value;
            select.dispatchEvent(new Event('change'));
            break;
          }
        }
      });
    });

    document.addEventListener('click', hideDoorPopups);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') hideDoorPopups();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-refonte"] && !Shopify.designMode) return;
  try {
    (function() {
    if (!document.body.classList.contains('vp-refonte')) return; // only on -refonte templates
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      var currentIndex = 0;
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var lightbox = gallery.querySelector('[data-gallery-lightbox]');
      var lightboxSlides = gallery.querySelectorAll('[data-lightbox-slide]');
      var mainArea = gallery.querySelector('[data-gallery-main]');
      var thumbsColumn = gallery.querySelector('[data-gallery-thumbs]');
      var thumbsUp = gallery.querySelector('[data-gallery-thumbs-up]');
      var thumbsDown = gallery.querySelector('[data-gallery-thumbs-down]');
      var counter = gallery.querySelector('[data-gallery-counter]');
      var zoom = gallery.querySelector('[data-gallery-zoom]');

      // Edge fades and arrows on the thumbnail column (see CSS): only where
      // there is more to scroll toward.
      function updateThumbFades() {
        if (!thumbsColumn) return;
        var above = thumbsColumn.scrollTop > 2;
        var below = thumbsColumn.scrollTop + thumbsColumn.clientHeight < thumbsColumn.scrollHeight - 2;
        thumbsColumn.toggleAttribute('data-more-above', above);
        thumbsColumn.toggleAttribute('data-more-below', below);
        if (thumbsUp) thumbsUp.classList.toggle('is-hidden', !above);
        if (thumbsDown) thumbsDown.classList.toggle('is-hidden', !below);
      }

      // Keep the active thumbnail in view when the main image changes
      // (main arrows, keyboard, lightbox), in either scroll direction.
      function revealThumb(thumb) {
        if (!thumbsColumn || !thumb) return;
        var col = thumbsColumn.getBoundingClientRect();
        var t = thumb.getBoundingClientRect();
        if (thumbsColumn.scrollHeight > thumbsColumn.clientHeight + 2) {
          if (t.top < col.top + 40) thumbsColumn.scrollBy({ top: t.top - col.top - 40 });
          else if (t.bottom > col.bottom - 40) thumbsColumn.scrollBy({ top: t.bottom - col.bottom + 40 });
        } else if (thumbsColumn.scrollWidth > thumbsColumn.clientWidth + 2) {
          if (t.left < col.left) thumbsColumn.scrollBy({ left: t.left - col.left - 8 });
          else if (t.right > col.right) thumbsColumn.scrollBy({ left: t.right - col.right + 8 });
        }
      }

      if (thumbsColumn) {
        var step = function(dir) {
          thumbsColumn.scrollBy({ top: dir * Math.max(thumbsColumn.clientHeight - 120, 160) });
        };
        if (thumbsUp) thumbsUp.addEventListener('click', function() { step(-1); });
        if (thumbsDown) thumbsDown.addEventListener('click', function() { step(1); });
        thumbsColumn.addEventListener('scroll', updateThumbFades, { passive: true });
        window.addEventListener('resize', updateThumbFades);
        updateThumbFades();
      }

      // YouTube player commands (the embed URL carries enablejsapi=1). A player loaded ahead of
      // the click is started in place instead of reloaded, and paused rather than unloaded when
      // another photo is shown, so coming back to it is instant.
      function playerCommand(iframe, func) {
        var send = function() {
          if (!iframe.contentWindow) return;
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*');
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');
        };
        if (iframe.dataset.loaded === '1') send();
        else iframe.addEventListener('load', function() { setTimeout(send, 150); }, { once: true });
      }

      // Load the player without playing: on a hover or touch of the video thumbnail (intent),
      // not with the page, so visitors who never open the video do not pay for it.
      function warmVideo(slide) {
        var iframe = slide && slide.querySelector('[data-video-embed]');
        if (!iframe || iframe.getAttribute('src')) return;
        iframe.addEventListener('load', function() { iframe.dataset.loaded = '1'; }, { once: true });
        iframe.setAttribute('src', iframe.getAttribute('data-video-embed'));
      }

      function mountVideo(slide, autoplay) {
        slides.forEach(function(s) {
          var iframe = s.querySelector('[data-video-embed]');
          if (!iframe) return;
          if (s !== slide) {
            if (iframe.getAttribute('src')) playerCommand(iframe, 'pauseVideo');
            return;
          }
          if (window.matchMedia('(hover: none)').matches) {
            // Phones: no start asked for by the page (iOS refused it and the player stayed
            // stuck). The player shows its own play button and the visitor taps it.
            if (!iframe.getAttribute('src')) iframe.setAttribute('src', iframe.getAttribute('data-video-embed'));
            return;
          }
          warmVideo(s);
          if (autoplay) playerCommand(iframe, 'playVideo');
        });
      }

      // Open the connections to YouTube once the page has loaded (about the cost of a DNS lookup).
      if (slides.length && gallery.querySelector('[data-video-embed]')) {
        var preconnect = function() {
          ['https://www.youtube.com', 'https://i.ytimg.com', 'https://www.google.com'].forEach(function(origin) {
            if (document.head.querySelector('link[rel="preconnect"][href="' + origin + '"]')) return;
            var link = document.createElement('link');
            link.rel = 'preconnect';
            link.href = origin;
            link.crossOrigin = '';
            document.head.appendChild(link);
          });
        };
        if (document.readyState === 'complete') preconnect();
        else window.addEventListener('load', preconnect, { once: true });
      }

      function showSlide(index, autoplay) {
        if (index < 0 || index >= slides.length) return;
        if (index !== currentIndex) gallery.classList.add('is-switching');
        currentIndex = index;
        slides.forEach(function(s) { s.classList.remove('product-gallery__slide--active'); });
        thumbs.forEach(function(t) { t.classList.remove('product-gallery__thumb--active'); });
        if (slides[index]) slides[index].classList.add('product-gallery__slide--active');
        if (thumbs[index]) thumbs[index].classList.add('product-gallery__thumb--active');
        revealThumb(thumbs[index]);
        if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
        var isVideo = slides[index] && slides[index].getAttribute('data-media-type') === 'external_video';
        if (mainArea) mainArea.classList.toggle('product-gallery__main--video', !!isVideo);
        mountVideo(isVideo ? slides[index] : null, !!autoplay);
      }

      function showByImageId(imageId) {
        if (!imageId) return false;
        var id = String(imageId);
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-image-id')) === id) {
            showSlide(i);
            return true;
          }
        }
        return false;
      }

      // Variant picker (product-form) asks the gallery to jump to the
      // variant-linked image when the shopper changes options.
      // Listen on document so snippet boot order doesn't matter.
      document.addEventListener('variant:image', function(e) {
        if (!e.detail || !e.detail.imageId) return;
        // Scope to the gallery that shares a product-hero with the event target
        // when possible; otherwise update this gallery (single-PDP case).
        var target = e.target;
        if (target && target.nodeType === 1) {
          var hero = target.closest && target.closest('.product-hero');
          if (hero && !hero.contains(gallery)) return;
        }
        showByImageId(e.detail.imageId);
      });

      function showLightboxSlide(index) {
        var found = false;
        lightboxSlides.forEach(function(s) {
          var on = parseInt(s.getAttribute('data-lightbox-slide'), 10) === index;
          s.classList.toggle('product-gallery__lightbox-slide--active', on);
          if (on) found = true;
          var video = s.querySelector('[data-video-embed]');
          if (!video) return;
          if (on) warmVideo(s);
          else if (video.getAttribute('src')) playerCommand(video, 'pauseVideo');
        });
        if (found) currentIndex = index;
        return found;
      }

      function stepLightbox(delta) {
        var indexes = [];
        lightboxSlides.forEach(function(s) {
          indexes.push(parseInt(s.getAttribute('data-lightbox-slide'), 10));
        });
        if (!indexes.length) return;
        var pos = indexes.indexOf(currentIndex);
        if (pos < 0) pos = 0;
        showLightboxSlide(indexes[(pos + delta + indexes.length) % indexes.length]);
      }

      if (slides[0] && slides[0].getAttribute('data-media-type') === 'external_video') {
        mountVideo(slides[0], false);
      }

      // Slides after the first are lazy so they don't compete with the LCP image. Once the page has
      // loaded, fetch them in the background so switching images is instant; a thumbnail hover or
      // touch fetches its own slide right away for clicks that come earlier.
      function loadSlideImage(slide) {
        var img = slide && slide.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      }
      if (document.readyState === 'complete') slides.forEach(loadSlideImage);
      else window.addEventListener('load', function() { slides.forEach(loadSlideImage); }, { once: true });

      thumbs.forEach(function(thumb) {
        var warm = function() {
          var target = slides[parseInt(thumb.getAttribute('data-gallery-thumb'), 10)];
          loadSlideImage(target);
          if (target && target.getAttribute('data-media-type') === 'external_video' && !window.matchMedia('(hover: none)').matches) warmVideo(target);
        };
        thumb.addEventListener('pointerenter', warm);
        thumb.addEventListener('pointerdown', warm);
        thumb.addEventListener('click', function() {
          var index = parseInt(this.getAttribute('data-gallery-thumb'), 10);
          var slide = slides[index];
          var isVideo = slide && slide.getAttribute('data-media-type') === 'external_video';
          showSlide(index, isVideo);
        });
      });

      // Arrows and swipe step through the photos; they never open the lightbox.
      // Named apart from the thumbnail column's `step` (a var in the same scope that would overwrite it).
      function stepPhoto(delta) {
        var next = (currentIndex + delta + slides.length) % slides.length;
        loadSlideImage(slides[next]);
        var isVideo = slides[next] && slides[next].getAttribute('data-media-type') === 'external_video';
        showSlide(next, isVideo);
      }
      gallery.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          stepPhoto(btn.hasAttribute('data-gallery-next') ? 1 : -1);
        });
      });
      if (mainArea && slides.length > 1) {
        var touchX = null;
        var swiped = false;
        mainArea.addEventListener('touchstart', function(e) { touchX = e.touches[0].clientX; swiped = false; }, { passive: true });
        mainArea.addEventListener('touchend', function(e) {
          if (touchX === null) return;
          var dx = e.changedTouches[0].clientX - touchX;
          touchX = null;
          if (Math.abs(dx) > 40) { swiped = true; stepPhoto(dx < 0 ? 1 : -1); }
        });
        mainArea.addEventListener('click', function(e) {
          if (swiped) { e.stopImmediatePropagation(); swiped = false; }
        }, true);
      }

      // Hover zoom (fine pointers only): the active photo at 2000 px follows the cursor.
      var ZOOM_FACTOR = 1.8;
      // 2000 px copies already downloaded. The zoom layer only shows once its copy is here:
      // shown earlier, its solid background hid the photo and the frame looked empty.
      var zoomReady = {};
      function preloadZoom(src) {
        if (!src || zoomReady[src] !== undefined) return;
        zoomReady[src] = false;
        var pre = new Image();
        pre.onload = function() { zoomReady[src] = true; };
        pre.onerror = function() { delete zoomReady[src]; };
        pre.src = src;
      }
      if (mainArea && zoom && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        mainArea.addEventListener('pointerenter', function() {
          var img = slides[currentIndex] && slides[currentIndex].querySelector('.product-gallery__image');
          if (img) preloadZoom(img.dataset.zoomSrc);
        });
        // Movement drives the zoom: off over the arrows or the counter, and always on the photo shown now.
        mainArea.addEventListener('pointermove', function(e) {
          var img = slides[currentIndex] && slides[currentIndex].querySelector('.product-gallery__image');
          var onControl = e.target.closest('.product-gallery__nav, .product-gallery__counter, .linked-products, a, button');
          if (!img || !img.dataset.zoomSrc || onControl) {
            mainArea.classList.remove('is-zooming');
            return;
          }
          if (zoomReady[img.dataset.zoomSrc] !== true) {
            preloadZoom(img.dataset.zoomSrc);
            mainArea.classList.remove('is-zooming');
            return;
          }
          var url = 'url("' + img.dataset.zoomSrc + '")';
          if (zoom.style.backgroundImage !== url) zoom.style.backgroundImage = url;
          // Magnify the product as drawn (object-fit: contain), not the frame: a narrow cellar
          // and a wide carafe both get the same 1.8x, and the point under the cursor stays put.
          var r = mainArea.getBoundingClientRect();
          var box = img.getBoundingClientRect();
          var ratio = (img.naturalWidth || 1) / (img.naturalHeight || 1);
          var dw = box.width / box.height > ratio ? box.height * ratio : box.width;
          var dh = dw / ratio;
          var dx = box.left + (box.width - dw) / 2 - r.left;
          var dy = box.top + (box.height - dh) / 2 - r.top;
          var cx = e.clientX - r.left;
          var cy = e.clientY - r.top;
          var u = Math.min(1, Math.max(0, (cx - dx) / dw));
          var v = Math.min(1, Math.max(0, (cy - dy) / dh));
          var zw = dw * ZOOM_FACTOR;
          var zh = dh * ZOOM_FACTOR;
          zoom.style.backgroundSize = zw + 'px ' + zh + 'px';
          zoom.style.backgroundPosition = (cx - u * zw) + 'px ' + (cy - v * zh) + 'px';
          mainArea.classList.add('is-zooming');
        });
        mainArea.addEventListener('pointerleave', function() { mainArea.classList.remove('is-zooming'); });
      }

      if (mainArea && lightbox) {
        mainArea.addEventListener('click', function() {
          var active = slides[currentIndex];
          if (active && active.getAttribute('data-media-type') === 'external_video') return;
          if (!showLightboxSlide(currentIndex)) return;
          lightbox.showModal();
        });
      }

      var closeBtn = gallery.querySelector('[data-lightbox-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() { lightbox.close(); });
      }

      // Esc, the close button and the backdrop all end in 'close': stop the video there.
      if (lightbox) {
        lightbox.addEventListener('close', function() {
          lightbox.querySelectorAll('[data-video-embed][src]').forEach(function(v) { playerCommand(v, 'pauseVideo'); });
        });
      }

      // Click on the dim backdrop area closes the modal.
      // Native <dialog>::backdrop clicks register with event.target === dialog,
      // so we can distinguish backdrop clicks from clicks on modal content.
      if (lightbox) {
        lightbox.addEventListener('click', function(e) {
          if (e.target === lightbox) lightbox.close();
        });
      }

      var prevBtn = gallery.querySelector('[data-lightbox-prev]');
      var nextBtn = gallery.querySelector('[data-lightbox-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          stepLightbox(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          stepLightbox(1);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
    if (document.body.classList.contains('vp-refonte')) return; // redesigned pages run the -refonte copy
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      var currentIndex = 0;
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var lightbox = gallery.querySelector('[data-gallery-lightbox]');
      var lightboxSlides = gallery.querySelectorAll('[data-lightbox-slide]');
      var mainArea = gallery.querySelector('[data-gallery-main]');
      var thumbsColumn = gallery.querySelector('[data-gallery-thumbs]');
      var thumbsUp = gallery.querySelector('[data-gallery-thumbs-up]');
      var thumbsDown = gallery.querySelector('[data-gallery-thumbs-down]');

      // Edge fades and arrows on the thumbnail column (see CSS): only where
      // there is more to scroll toward.
      function updateThumbFades() {
        if (!thumbsColumn) return;
        var above = thumbsColumn.scrollTop > 2;
        var below = thumbsColumn.scrollTop + thumbsColumn.clientHeight < thumbsColumn.scrollHeight - 2;
        thumbsColumn.toggleAttribute('data-more-above', above);
        thumbsColumn.toggleAttribute('data-more-below', below);
        if (thumbsUp) thumbsUp.classList.toggle('is-hidden', !above);
        if (thumbsDown) thumbsDown.classList.toggle('is-hidden', !below);
      }

      // Keep the active thumbnail in view when the main image changes
      // (main arrows, keyboard, lightbox), in either scroll direction.
      function revealThumb(thumb) {
        if (!thumbsColumn || !thumb) return;
        var col = thumbsColumn.getBoundingClientRect();
        var t = thumb.getBoundingClientRect();
        if (thumbsColumn.scrollHeight > thumbsColumn.clientHeight + 2) {
          if (t.top < col.top + 40) thumbsColumn.scrollBy({ top: t.top - col.top - 40 });
          else if (t.bottom > col.bottom - 40) thumbsColumn.scrollBy({ top: t.bottom - col.bottom + 40 });
        } else if (thumbsColumn.scrollWidth > thumbsColumn.clientWidth + 2) {
          if (t.left < col.left) thumbsColumn.scrollBy({ left: t.left - col.left - 8 });
          else if (t.right > col.right) thumbsColumn.scrollBy({ left: t.right - col.right + 8 });
        }
      }

      if (thumbsColumn) {
        var step = function(dir) {
          thumbsColumn.scrollBy({ top: dir * Math.max(thumbsColumn.clientHeight - 120, 160) });
        };
        if (thumbsUp) thumbsUp.addEventListener('click', function() { step(-1); });
        if (thumbsDown) thumbsDown.addEventListener('click', function() { step(1); });
        thumbsColumn.addEventListener('scroll', updateThumbFades, { passive: true });
        window.addEventListener('resize', updateThumbFades);
        updateThumbFades();
      }

      function mountVideo(slide, autoplay) {
        slides.forEach(function(s) {
          var iframe = s.querySelector('[data-video-embed]');
          if (!iframe) return;
          if (s !== slide) {
            if (iframe.getAttribute('src')) iframe.removeAttribute('src');
            return;
          }
          var src = iframe.getAttribute('data-video-embed');
          if (!src) return;
          if (autoplay) {
            src += (src.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1';
          }
          if (iframe.getAttribute('src') !== src) iframe.setAttribute('src', src);
        });
      }

      function showSlide(index, autoplay) {
        if (index < 0 || index >= slides.length) return;
        currentIndex = index;
        slides.forEach(function(s) { s.classList.remove('product-gallery__slide--active'); });
        thumbs.forEach(function(t) { t.classList.remove('product-gallery__thumb--active'); });
        if (slides[index]) slides[index].classList.add('product-gallery__slide--active');
        if (thumbs[index]) thumbs[index].classList.add('product-gallery__thumb--active');
        revealThumb(thumbs[index]);
        var isVideo = slides[index] && slides[index].getAttribute('data-media-type') === 'external_video';
        if (mainArea) mainArea.classList.toggle('product-gallery__main--video', !!isVideo);
        mountVideo(isVideo ? slides[index] : null, !!autoplay);
      }

      function showByImageId(imageId) {
        if (!imageId) return false;
        var id = String(imageId);
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-image-id')) === id) {
            showSlide(i);
            return true;
          }
        }
        return false;
      }

      // Variant picker (product-form) asks the gallery to jump to the
      // variant-linked image when the shopper changes options.
      // Listen on document so snippet boot order doesn't matter.
      document.addEventListener('variant:image', function(e) {
        if (!e.detail || !e.detail.imageId) return;
        // Scope to the gallery that shares a product-hero with the event target
        // when possible; otherwise update this gallery (single-PDP case).
        var target = e.target;
        if (target && target.nodeType === 1) {
          var hero = target.closest && target.closest('.product-hero');
          if (hero && !hero.contains(gallery)) return;
        }
        showByImageId(e.detail.imageId);
      });

      function showLightboxSlide(index) {
        var found = false;
        lightboxSlides.forEach(function(s) {
          var on = parseInt(s.getAttribute('data-lightbox-slide'), 10) === index;
          s.classList.toggle('product-gallery__lightbox-slide--active', on);
          if (on) found = true;
        });
        if (found) currentIndex = index;
        return found;
      }

      function stepLightbox(delta) {
        var indexes = [];
        lightboxSlides.forEach(function(s) {
          indexes.push(parseInt(s.getAttribute('data-lightbox-slide'), 10));
        });
        if (!indexes.length) return;
        var pos = indexes.indexOf(currentIndex);
        if (pos < 0) pos = 0;
        showLightboxSlide(indexes[(pos + delta + indexes.length) % indexes.length]);
      }

      if (slides[0] && slides[0].getAttribute('data-media-type') === 'external_video') {
        mountVideo(slides[0], false);
      }

      // Slides after the first are lazy so they don't compete with the LCP image. Once the page has
      // loaded, fetch them in the background so switching images is instant; a thumbnail hover or
      // touch fetches its own slide right away for clicks that come earlier.
      function loadSlideImage(slide) {
        var img = slide && slide.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      }
      if (document.readyState === 'complete') slides.forEach(loadSlideImage);
      else window.addEventListener('load', function() { slides.forEach(loadSlideImage); }, { once: true });

      thumbs.forEach(function(thumb) {
        var warm = function() { loadSlideImage(slides[parseInt(thumb.getAttribute('data-gallery-thumb'), 10)]); };
        thumb.addEventListener('pointerenter', warm);
        thumb.addEventListener('pointerdown', warm);
        thumb.addEventListener('click', function() {
          var index = parseInt(this.getAttribute('data-gallery-thumb'), 10);
          var slide = slides[index];
          var isVideo = slide && slide.getAttribute('data-media-type') === 'external_video';
          showSlide(index, isVideo);
        });
      });

      if (mainArea && lightbox) {
        mainArea.addEventListener('click', function() {
          var active = slides[currentIndex];
          if (active && active.getAttribute('data-media-type') === 'external_video') return;
          if (!showLightboxSlide(currentIndex)) return;
          lightbox.showModal();
        });
      }

      var closeBtn = gallery.querySelector('[data-lightbox-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() { lightbox.close(); });
      }

      // Click on the dim backdrop area closes the modal.
      // Native <dialog>::backdrop clicks register with event.target === dialog,
      // so we can distinguish backdrop clicks from clicks on modal content.
      if (lightbox) {
        lightbox.addEventListener('click', function(e) {
          if (e.target === lightbox) lightbox.close();
        });
      }

      var prevBtn = gallery.querySelector('[data-lightbox-prev]');
      var nextBtn = gallery.querySelector('[data-lightbox-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          stepLightbox(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          stepLightbox(1);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-animations"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__scrollAnimInit) return;
    window.__scrollAnimInit = true;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      document.querySelectorAll('[data-animate]').forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }

    function applyStagger(parent) {
      var children = parent.querySelectorAll(':scope > [data-animate]');
      children.forEach(function(child, i) {
        child.style.animationDelay = (i * 0.1) + 's';
      });
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;

        if (el.hasAttribute('data-stagger')) {
          applyStagger(el);
          var children = el.querySelectorAll(':scope > [data-animate]');
          children.forEach(function(child) {
            child.classList.add('is-visible');
          });
        }

        el.classList.add('is-visible');
        observer.unobserve(el);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('[data-animate]').forEach(function(el) {
      observer.observe(el);
    });

    document.querySelectorAll('[data-stagger]').forEach(function(el) {
      observer.observe(el);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vp-filter-bar"] && !Shopify.designMode) return;
  try {
    (function() {
    var requestToken = 0;
    var appliedUrl = window.location.href;
    var liquidSnap = { grid: null, html: '', count: '', replaced: false, clean: false, page: '1' };

    /* Set by a page click; paintGrid scrolls once the new cards are in, then clears it. */
    var scrollTopRequestedAt = 0;

    function shopifyPage() {
      return new URL(window.location.href).searchParams.get('page') || '1';
    }
    var aliasesByParam = {};
    var motion = {
      id: 0,
      timer: 0,
      ghosts: [],
      grid: null,
      parent: null,
      parentPosition: '',
      mode: '',
      finalHtml: null,
      savedColumns: '',
    };
    var MOTION_MS = 200;

    function stringsFrom(root) {
      var node = root.querySelector('[data-vp-filter-strings]');
      try {
        return JSON.parse(node ? node.textContent : '{}');
      } catch (e) {
        return {};
      }
    }

    function esc(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function handleFromHref(href) {
      if (!href) return '';
      var path = href;
      try {
        path = new URL(href, window.location.origin).pathname;
      } catch (e) {
        path = String(href).split('?')[0];
      }
      var marker = '/products/';
      var at = path.indexOf(marker);
      if (at === -1) return '';
      var handle = path.slice(at + marker.length).split('/')[0];
      try { handle = decodeURIComponent(handle); } catch (e2) { /* keep raw */ }
      return handle;
    }

    function productKey(el) {
      if (!el || !el.classList || !el.classList.contains('collection-page__product')) return '';
      var marked = el.getAttribute('data-vp-product');
      if (marked) return marked;
      var link = el.querySelector('a[href*="/products/"]');
      if (!link) return '';
      return handleFromHref(link.getAttribute('href'));
    }

    function afterPaint(id, play) {
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(function() {
          if (id !== motion.id) return;
          play();
          motion.timer = window.setTimeout(function() { finishMotion(id); }, MOTION_MS + 30);
        });
      });
    }

    function childKeys(root) {
      var keys = [];
      Array.prototype.forEach.call(root.children, function(el) {
        keys.push(productKey(el));
      });
      return keys;
    }

    function sameKeys(a, b) {
      if (a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
      return true;
    }

    function reduceMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function settleMotion() {
      motion.id += 1;
      if (motion.timer) {
        window.clearTimeout(motion.timer);
        motion.timer = 0;
      }
      motion.ghosts.forEach(function(node) { node.remove(); });
      motion.ghosts = [];
      var grid = motion.grid;
      if (grid && motion.mode === 'crossfade') {
        grid.classList.remove('vp-grid-crossfading');
        grid.style.gridTemplateColumns = motion.savedColumns;
        if (motion.finalHtml != null) grid.innerHTML = motion.finalHtml;
      }
      if (grid) {
        grid.querySelectorAll('.collection-page__product, .vp-card-arrive').forEach(function(el) {
          el.style.transform = '';
          el.style.transition = '';
          el.classList.remove('vp-card-arrive', 'vp-card-arrive--on');
        });
      }
      if (motion.parent) motion.parent.style.position = motion.parentPosition;
      motion.mode = '';
      motion.finalHtml = null;
      motion.parent = null;
    }

    function finishMotion(id) {
      if (id !== motion.id) return;
      var mode = motion.mode;
      var grid = motion.grid;
      var html = motion.finalHtml;
      motion.mode = mode === 'crossfade' ? 'crossfade' : '';
      if (mode === 'crossfade' && grid && html != null) {
        motion.finalHtml = html;
      }
      settleMotion();
    }

    /* Le HTML Liquid garde data-animate (opacity: 0) jusqu'à l'observer
       de scroll, qui ne voit pas les nœuds insérés ensuite. Sans retrait,
       revenir à Tout remet le compte et une grille invisible. */
    function visibleHtml(html) {
      if (!html || html.indexOf('data-animate') === -1) return html;
      var probe = document.createElement('div');
      probe.innerHTML = html;
      probe.querySelectorAll('[data-animate]').forEach(function(el) {
        el.removeAttribute('data-animate');
      });
      return probe.innerHTML;
    }

    function swapGrid(grid, html) {
      settleMotion();
      var id = motion.id;
      motion.grid = grid;
      html = visibleHtml(html);
      motion.finalHtml = html;
      if (reduceMotion() || !grid.firstElementChild) {
        grid.innerHTML = html;
        motion.finalHtml = null;
        return;
      }

      var probe = document.createElement('div');
      probe.innerHTML = html;
      var nextKeys = childKeys(probe);
      var prevKeys = childKeys(grid);
      if (sameKeys(prevKeys, nextKeys)) {
        grid.innerHTML = html;
        motion.finalHtml = null;
        return;
      }

      var prevSet = {};
      var nextSet = {};
      var prevCount = 0;
      var nextCount = 0;
      var shared = 0;
      prevKeys.forEach(function(key) {
        if (!key || prevSet[key]) return;
        prevSet[key] = true;
        prevCount += 1;
      });
      nextKeys.forEach(function(key) {
        if (!key || nextSet[key]) return;
        nextSet[key] = true;
        nextCount += 1;
        if (prevSet[key]) shared += 1;
      });

      if (prevCount > 0 && nextCount > 0 && shared === 0) {
        crossfadeGrid(grid, html, id);
        return;
      }
      flipGrid(grid, html, nextSet, id);
    }

    function crossfadeGrid(grid, html, id) {
      motion.mode = 'crossfade';
      motion.savedColumns = grid.style.gridTemplateColumns;
      var layerStyle = '--columns-desktop:' + (grid.style.getPropertyValue('--columns-desktop') || '3')
        + ';--columns-mobile:' + (grid.style.getPropertyValue('--columns-mobile') || '2') + ';';
      var oldLayer = document.createElement('div');
      oldLayer.className = 'collection-page__grid vp-grid-layer';
      oldLayer.style.cssText = layerStyle;
      oldLayer.setAttribute('aria-hidden', 'true');
      oldLayer.setAttribute('inert', '');
      while (grid.firstChild) oldLayer.appendChild(grid.firstChild);
      var newLayer = document.createElement('div');
      newLayer.className = 'collection-page__grid vp-grid-layer';
      newLayer.style.cssText = layerStyle;
      newLayer.style.opacity = '0';
      newLayer.innerHTML = html;
      grid.classList.add('vp-grid-crossfading');
      grid.style.gridTemplateColumns = '1fr';
      grid.appendChild(oldLayer);
      grid.appendChild(newLayer);
      afterPaint(id, function() {
        oldLayer.style.opacity = '0';
        newLayer.style.opacity = '1';
      });
    }

    function flipGrid(grid, html, nextSet, id) {
      motion.mode = 'flip';
      var parent = grid.parentElement || grid;
      motion.parent = parent;
      motion.parentPosition = parent.style.position;
      if (window.getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
      var parentBox = parent.getBoundingClientRect();
      var parentStyle = window.getComputedStyle(parent);
      var borderTop = parseFloat(parentStyle.borderTopWidth) || 0;
      var borderLeft = parseFloat(parentStyle.borderLeftWidth) || 0;
      var first = {};
      Array.prototype.forEach.call(grid.children, function(el) {
        var key = productKey(el);
        var box = el.getBoundingClientRect();
        if (key && nextSet[key]) {
          first[key] = box;
          return;
        }
        var ghost = el.cloneNode(true);
        ghost.removeAttribute('data-animate');
        ghost.classList.remove('is-visible');
        ghost.classList.add('vp-card-ghost');
        ghost.setAttribute('aria-hidden', 'true');
        ghost.style.position = 'absolute';
        ghost.style.left = (box.left - parentBox.left - borderLeft) + 'px';
        ghost.style.top = (box.top - parentBox.top - borderTop) + 'px';
        ghost.style.width = box.width + 'px';
        ghost.style.height = box.height + 'px';
        ghost.style.transition = 'none';
        ghost.style.animation = 'none';
        ghost.style.opacity = '1';
        ghost.style.transform = 'none';
        parent.appendChild(ghost);
        motion.ghosts.push(ghost);
      });

      grid.innerHTML = html;
      var stayers = [];
      Array.prototype.forEach.call(grid.children, function(el) {
        var key = productKey(el);
        var old = key && first[key];
        if (!old) {
          el.classList.add('vp-card-arrive');
          return;
        }
        var box = el.getBoundingClientRect();
        var dx = old.left - box.left;
        var dy = old.top - box.top;
        if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return;
        el.style.transition = 'none';
        el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
        stayers.push(el);
      });
      void grid.offsetWidth;

      afterPaint(id, function() {
        stayers.forEach(function(el) {
          el.style.transition = 'transform ' + MOTION_MS + 'ms ease-out';
          el.style.transform = '';
        });
        motion.ghosts.forEach(function(ghost) {
          ghost.style.transition = 'opacity ' + MOTION_MS + 'ms ease-out, transform ' + MOTION_MS + 'ms ease-out';
          ghost.style.opacity = '0';
          ghost.style.transform = 'scale(0.94)';
        });
        grid.querySelectorAll('.vp-card-arrive').forEach(function(el) {
          el.classList.add('vp-card-arrive--on');
        });
      });
    }

    function narrowingKeys(url) {
      var keys = [];
      url.searchParams.forEach(function(_value, key) {
        if (keys.indexOf(key) !== -1) return;
        if (key.indexOf('vp.') === 0 || key.indexOf('filter.') === 0) keys.push(key);
      });
      return keys;
    }

    function hasNarrowing(url) {
      return narrowingKeys(url).some(function(key) {
        if (key === 'vp.page') return false;
        return url.searchParams.getAll(key).some(function(value) { return value; });
      });
    }

    function captureCleanLiquid() {
      if (liquidSnap.clean) return;
      var url = new URL(window.location.href);
      if (hasNarrowing(url)) return;
      var root = document.querySelector('[data-vp-filter-bar]');
      var section = root && root.closest('.collection-page');
      var grid = section && section.querySelector('[data-vp-product-grid]');
      if (!section || !grid) return;
      var count = section.querySelector('[data-vp-count]');
      liquidSnap = {
        grid: grid,
        html: grid.innerHTML,
        count: count ? count.textContent : '',
        replaced: false,
        clean: true,
        page: shopifyPage(),
      };
    }

    function endpoint(root, pageUrl) {
      var params = new URLSearchParams(pageUrl.search);
      params.set('handle', root.getAttribute('data-handle') || '');
      var collectionId = root.getAttribute('data-collection-id');
      if (collectionId) params.set('collection_id', collectionId);
      params.set('per_page', root.getAttribute('data-per-page') || '24');
      params.set('lang', (document.documentElement.lang || 'fr').slice(0, 2));
      return '/apps/vp/collection-filters?' + vpJoinRepeated(params).toString();
    }

    /* Shopify's app proxy fails its signature check on a repeated key (400): one comma list per filter,
       which vp-app reads as either value. The page address keeps the repeated keys. */
    function vpJoinRepeated(params) {
      var out = new URLSearchParams();
      params.forEach(function(value, key) { out.set(key, out.has(key) ? out.get(key) + ',' + value : value); });
      return out;
    }

    function cardHtml(product, showVendor, addLabel) {
      var badges = '';
      if (product.saleBadge) badges += '<span class="collection-page__badge">' + esc(product.saleBadge) + '</span>';
      /* Same pills as snippets/promo-badge.liquid: words top left (under "Solde"), amount top right. */
      if (product.promoWord) badges += '<span class="promo-badge promo-badge--phrase promo-badge--card">' + esc(product.promoWord) + '</span>';
      if (product.promoDiscount) badges += '<span class="promo-badge promo-badge--amount promo-badge--card">' + esc(product.promoDiscount) + '</span>';
      var image = product.image
        ? '<img src="' + esc(product.image) + '" alt="' + esc(product.title) + '" loading="lazy" width="600">'
        : '';
      var atc = '';
      if (product.available && product.variantId) {
        atc = '<button type="button" class="collection-page__atc" data-quick-add data-variant-id="' + esc(product.variantId) + '" data-product-type="' + esc(product.productType) + '" data-sku="' + esc(product.sku) + '" aria-label="' + esc(addLabel) + '"><span>' + esc(addLabel) + '</span></button>';
      }
      var vendor = showVendor && product.vendor
        ? '<span class="collection-page__product-vendor">' + esc(product.vendor) + '</span>'
        : '';
      var merch = product.merchLabel ? '<span class="merch-label merch-label--eyebrow">' + esc(product.merchLabel) + '</span>' : '';
      var compare = product.compareLabel
        ? '<span class="collection-page__price-compare">' + esc(product.compareLabel) + '</span>'
        : '';
      var from = product.fromLabel ? esc(product.fromLabel) + ' ' : '';
      var eco = product.ecofeeNote ? '<span class="ecofee-note ecofee-note--card">' + esc(product.ecofeeNote) + '</span>' : '';
      var saleClass = product.compareLabel ? ' collection-page__price--sale' : '';
      return '<div class="collection-page__product" data-vp-product="' + esc(handleFromHref(product.url)) + '">' +
        '<a href="' + esc(product.url) + '" class="collection-page__product-image">' + image + badges + atc + '</a>' +
        '<a href="' + esc(product.url) + '" class="collection-page__product-info">' +
          '<div class="merch-label-row">' + vendor + merch + '</div>' +
          '<h3 class="collection-page__product-title">' + esc(product.title) + '</h3>' +
          '<div class="collection-page__product-price">' + compare +
            '<span class="collection-page__price' + saleClass + '">' + from + esc(product.priceLabel) + '</span>' +
            eco +
          '</div>' +
        '</a></div>';
    }

    function rememberLiquid(section, grid) {
      if (liquidSnap.clean && liquidSnap.grid === grid) return;
      if (liquidSnap.grid === grid) return;
      var count = section.querySelector('[data-vp-count]');
      liquidSnap = {
        grid: grid,
        html: grid.innerHTML,
        count: count ? count.textContent : '',
        replaced: false,
        clean: false,
        page: shopifyPage(),
      };
    }

    function showLiquidChrome(section, countText) {
      var count = section.querySelector('[data-vp-count]');
      if (count && countText != null) count.textContent = countText;
      var vpNav = section.querySelector('[data-vp-pagination]');
      if (vpNav) vpNav.remove();
      section.querySelectorAll('.collection-page__pagination').forEach(function(nav) {
        nav.hidden = false;
      });
      var empty = section.querySelector('.collection-page__empty');
      if (empty) empty.hidden = false;
    }

    function restoreLiquid(section) {
      var grid = section.querySelector('[data-vp-product-grid]');
      if (!grid || !liquidSnap.replaced) return;
      // The snapshot is the page the visitor arrived on; after a filter the list restarts at page 1.
      if (liquidSnap.clean && liquidSnap.grid === grid && liquidSnap.html && liquidSnap.page === shopifyPage()) {
        swapGrid(grid, liquidSnap.html);
        liquidSnap.replaced = false;
        showLiquidChrome(section, liquidSnap.count);
        return;
      }
      document.dispatchEvent(new CustomEvent('vp:need-unfiltered-grid'));
    }

    window.vpReplaceGridHtml = function(html, countText) {
      var root = document.querySelector('[data-vp-filter-bar]');
      var section = root && root.closest('.collection-page');
      var grid = section && section.querySelector('[data-vp-product-grid]');
      if (!section || !grid) return;
      swapGrid(grid, html);
      showLiquidChrome(section, countText);
      liquidSnap = {
        grid: grid,
        html: html,
        count: countText || '',
        replaced: false,
        clean: true,
        page: shopifyPage(),
      };
    };

    function paintGrid(root, data, strings) {
      var section = root.closest('.collection-page');
      if (!section) return;
      var grid = section.querySelector('[data-vp-product-grid]');
      var empty = section.querySelector('.collection-page__empty');
      var showVendor = root.getAttribute('data-show-vendor') === '1';
      if (!grid) {
        var main = section.querySelector('.collection-page__main');
        if (!main) return;
        grid = document.createElement('div');
        grid.className = 'collection-page__grid';
        grid.setAttribute('data-vp-product-grid', '');
        grid.style.setProperty('--columns-desktop', root.getAttribute('data-columns-desktop') || '3');
        grid.style.setProperty('--columns-mobile', root.getAttribute('data-columns-mobile') || '2');
        main.appendChild(grid);
      }
      rememberLiquid(section, grid);
      section.querySelectorAll('.collection-page__pagination:not([data-vp-pagination])').forEach(function(nav) {
        nav.hidden = true;
      });
      var html = (!data.products || !data.products.length)
        ? '<div class="collection-page__empty"><p>' + esc(strings.empty || '') + '</p></div>'
        : data.products.map(function(product) {
            return cardHtml(product, showVendor, strings.add || '');
          }).join('');
      swapGrid(grid, html);
      if (empty) empty.hidden = true;
      if (scrollTopRequestedAt && Date.now() - scrollTopRequestedAt < 15000 && window.vpScrollPageTop) {
        window.vpScrollPageTop();
      }
      scrollTopRequestedAt = 0;
      liquidSnap.replaced = true;
      var count = section.querySelector('[data-vp-count]');
      if (count) {
        var template = (data.total === 1 && root.getAttribute('data-count-template-one')) || root.getAttribute('data-count-template') || '__COUNT__';
        count.textContent = template.replace('__COUNT__', String(data.total));
      }
      var existing = section.querySelector('[data-vp-pagination]');
      if (existing) existing.remove();
      if (data.pages > 1) {
        var nav = document.createElement('nav');
        nav.className = 'collection-page__pagination';
        nav.setAttribute('data-vp-pagination', '');
        nav.setAttribute('aria-label', 'Pagination');
        if (data.page > 1) {
          nav.insertAdjacentHTML('beforeend', '<button type="button" class="collection-page__pagination-btn" data-vp-page="' + (data.page - 1) + '" aria-label="' + esc(strings.previous || '') + '">‹</button>');
        }
        nav.insertAdjacentHTML('beforeend', '<span class="collection-page__pagination-link collection-page__pagination-link--current">' + data.page + '</span>');
        if (data.page < data.pages) {
          nav.insertAdjacentHTML('beforeend', '<button type="button" class="collection-page__pagination-btn" data-vp-page="' + (data.page + 1) + '" aria-label="' + esc(strings.next || '') + '">›</button>');
        }
        grid.insertAdjacentElement('afterend', nav);
      }
    }

    var chevron = '<svg class="collection-page__chevron" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var check = '<svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4L3.5 6.5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var closeIcon = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M2 2L8 8M8 2L2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    function shownValues(group) {
      return (group.values || []).filter(function(value) {
        return !!value.active || Number(value.count) > 0;
      });
    }

    function valueItemHtml(group, value) {
      var box = value.active
        ? '<span class="collection-page__checkbox collection-page__checkbox--checked" aria-hidden="true">' + check + '</span>'
        : '<span class="collection-page__checkbox" aria-hidden="true"></span>';
      var count = group.showCount === false ? '' : ' <span class="collection-page__filter-count">(' + value.count + ')</span>';
      var legacyAttr = group.legacy ? ' data-vp-legacy="' + esc(group.legacy) + '"' : '';
      var aliasAttr = group.aliases && group.aliases.length ? ' data-vp-aliases="' + esc(group.aliases.join(',')) + '"' : '';
      return '<li class="collection-page__filter-item"><button type="button" class="collection-page__filter-value' + (value.active ? ' collection-page__filter-value--active' : '') + '" data-vp-param="' + esc(group.param) + '" data-vp-value="' + esc(value.value) + '"' + legacyAttr + aliasAttr + ' aria-pressed="' + (value.active ? 'true' : 'false') + '">' + box + '<span class="collection-page__filter-value-label">' + esc(value.label) + '</span>' + count + '</button></li>';
    }

    function verticalGroups(groups) {
      var list = (groups || []).filter(function(group) {
        return group && group.placement !== 'h1' && group.placement !== 'h2';
      });
      if (!document.querySelector('[data-vp-filter-bar][data-vp-sidebar-brand]')) return list;
      return (groups || []).filter(function(group) {
        return group && group.placement === 'h1';
      }).concat(list);
    }

    function groupsHtml(data) {
      return verticalGroups(data.groups).filter(function(group) {
        return shownValues(group).length;
      }).map(function(group) {
        var values = shownValues(group).map(function(value) {
          return valueItemHtml(group, value);
        }).join('');
        return '<details class="collection-page__filter-group" data-vp-group="' + esc(group.param) + '" open><summary class="collection-page__filter-label"><span class="collection-page__filter-label-text">' + esc(group.label) + '</span>' + chevron + '</summary><div class="collection-page__filter-values"><ul class="collection-page__filter-list">' + values + '</ul></div></details>';
      }).join('');
    }

    function syncValue(li, value, group) {
      var btn = li.querySelector('[data-vp-value]');
      if (!btn) return;
      if (group && group.aliases && group.aliases.length) btn.setAttribute('data-vp-aliases', group.aliases.join(','));
      var on = !!value.active;
      if ((btn.getAttribute('aria-pressed') === 'true') !== on) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('collection-page__filter-value--active', on);
        var box = btn.querySelector('.collection-page__checkbox');
        if (box) {
          box.classList.toggle('collection-page__checkbox--checked', on);
          box.innerHTML = on ? check : '';
        }
      }
      var countEl = btn.querySelector('.collection-page__filter-count');
      var countLabel = '(' + value.count + ')';
      if (countEl && countEl.textContent !== countLabel) countEl.textContent = countLabel;
      var labelEl = btn.querySelector('.collection-page__filter-value-label');
      if (labelEl && value.label && labelEl.textContent !== value.label) labelEl.textContent = value.label;
    }

    function placeBeforeNext(parent, node, previous) {
      if (previous) {
        if (previous.nextSibling !== node) parent.insertBefore(node, previous.nextSibling);
      } else if (parent.firstChild !== node) {
        parent.insertBefore(node, parent.firstChild);
      }
    }

    function patchValues(details, group) {
      var ul = details.querySelector('.collection-page__filter-list');
      if (!ul) return;
      var existing = {};
      Array.prototype.forEach.call(ul.querySelectorAll(':scope > .collection-page__filter-item'), function(li) {
        var btn = li.querySelector('[data-vp-value]');
        if (btn) existing[btn.getAttribute('data-vp-value')] = li;
      });
      var seen = {};
      var previous = null;
      shownValues(group).forEach(function(value) {
        seen[value.value] = true;
        var li = existing[value.value];
        if (!li) {
          ul.insertAdjacentHTML('beforeend', valueItemHtml(group, value));
          li = ul.lastElementChild;
        } else {
          syncValue(li, value, group);
        }
        placeBeforeNext(ul, li, previous);
        previous = li;
      });
      Object.keys(existing).forEach(function(value) {
        if (!seen[value]) existing[value].remove();
      });
    }

    function patchGroups(container, data) {
      var groups = verticalGroups(data.groups);
      if (!container.querySelector(':scope > .collection-page__filter-group')) {
        container.innerHTML = groupsHtml(data);
        return;
      }
      var existing = {};
      Array.prototype.forEach.call(container.querySelectorAll(':scope > .collection-page__filter-group'), function(el) {
        var param = el.getAttribute('data-vp-group');
        if (param) existing[param] = el;
      });
      var seen = {};
      var previous = null;
      groups.forEach(function(group) {
        if (!group || !group.param || !shownValues(group).length) return;
        seen[group.param] = true;
        var details = existing[group.param];
        if (!details) {
          container.insertAdjacentHTML('beforeend', groupsHtml({ groups: [group] }));
          details = container.lastElementChild;
        } else {
          var title = details.querySelector('.collection-page__filter-label-text');
          if (title && group.label && title.textContent !== group.label) title.textContent = group.label;
          patchValues(details, group);
        }
        placeBeforeNext(container, details, previous);
        previous = details;
      });
      Object.keys(existing).forEach(function(param) {
        if (!seen[param]) existing[param].remove();
      });
    }

    function clearGroupParams(url, group) {
      if (!group) return;
      if (group.param) url.searchParams.delete(group.param);
      if (group.legacy === 'filter.v.price') {
        url.searchParams.delete('filter.v.price.gte');
        url.searchParams.delete('filter.v.price.lte');
        return;
      }
      if (group.legacy) url.searchParams.delete(group.legacy);
      (group.aliases || []).forEach(function(name) { url.searchParams.delete(name); });
    }

    function axisHref(group, value, groups, level) {
      var url = new URL(window.location.href);
      clearGroupParams(url, group);
      if (level === 'h1') {
        groups.forEach(function(other) {
          if (other && other.placement === 'h2') clearGroupParams(url, other);
        });
      }
      if (value) {
        if (group.legacy === 'filter.v.price') {
          if (typeof value.minCents === 'number') {
            url.searchParams.set('filter.v.price.gte', String(Math.round(value.minCents / 100)));
          }
          if (value.maxCents != null && value.maxCents !== '') {
            url.searchParams.set('filter.v.price.lte', String(Math.round(value.maxCents / 100)));
          }
        } else if (group.legacy) {
          url.searchParams.append(group.legacy, value.value);
        }
      }
      url.searchParams.delete('vp.page');
      var drop = [group.param];
      if (level === 'h1') {
        groups.forEach(function(other) {
          if (other && other.placement === 'h2' && other.param) drop.push(other.param);
        });
      }
      return { href: url.pathname + url.search, drop: drop.join(',') };
    }

    function familleAxeKey(nav, famille) {
      var raw = nav.getAttribute('data-famille-axes');
      if (!raw || !famille) return { limited: false, wanted: '' };
      var axes = [];
      try { axes = JSON.parse(raw); } catch (e) { return { limited: false, wanted: '' }; }
      if (!Array.isArray(axes) || !axes.length) return { limited: false, wanted: '' };
      var keys = {};
      var wanted = '';
      axes.forEach(function(fam) {
        if (!fam || !fam.axe2) return;
        var key = fam.axe2 === 'product_type' ? 'product_type' : String(fam.axe2).replace(/^custom\./, '');
        keys[key] = true;
        if (fam.famille === famille) wanted = key;
      });
      return { limited: true, keys: keys, wanted: wanted };
    }

    function paintAxis(data) {
      var nav = document.querySelector('[data-vp-filter-axis]');
      if (!nav || !data || !Array.isArray(data.groups)) return;
      var groups = data.groups.filter(function(group) {
        return group && (group.placement === 'h1' || group.placement === 'h2') && shownValues(group).length;
      });
      var h1 = groups.filter(function(group) { return group.placement === 'h1'; });
      var h1Active = false;
      var activeFamille = '';
      h1.forEach(function(group) {
        shownValues(group).forEach(function(value) {
          if (!value.active) return;
          h1Active = true;
          activeFamille = value.value;
        });
      });
      var axe = familleAxeKey(nav, activeFamille);
      var allLabel = nav.getAttribute('data-all-label') || 'Tout';
      var typeLabel = nav.getAttribute('data-type-label') || '';
      var seriesLabel = nav.getAttribute('data-series-label') || '';
      var brandLabel = nav.getAttribute('data-brand-label') || '';
      /* O-2051: on grouped pages, series pills open the series page (map from vp-filter-axis). */
      var seriesPages = {};
      try { seriesPages = JSON.parse(nav.getAttribute('data-series-pages') || '{}'); } catch (e) { seriesPages = {}; }
      var html = h1.map(function(group) {
        var tout = axisHref(group, null, groups, 'h1');
        var anyActive = shownValues(group).some(function(value) { return !!value.active; });
        var pills = '<a href="' + esc(tout.href) + '" class="brand-axis__pill' + (anyActive ? '' : ' brand-axis__pill--active') + '" data-vp-drop="' + esc(tout.drop) + '">' + esc(allLabel) + '</a>';
        shownValues(group).forEach(function(value) {
          var link = axisHref(group, value, groups, 'h1');
          pills += '<a href="' + esc(link.href) + '" class="brand-axis__pill' + (value.active ? ' brand-axis__pill--active' : '') + '" data-vp-drop="' + esc(link.drop) + '">' + esc(value.label) + '</a>';
        });
        return '<div class="brand-axis__row" data-vp-axis-row="h1" data-vp-axis-key="' + esc(group.key) + '">' + pills + '</div>';
      }).join('');
      if (h1Active) {
        groups.filter(function(group) { return group.placement === 'h2'; }).forEach(function(group) {
          if (axe.limited && axe.keys[group.key] && group.key !== axe.wanted) return;
          var tout = axisHref(group, null, groups, 'h2');
          var anyActive = shownValues(group).some(function(value) { return !!value.active; });
          var pills = '<a href="' + esc(tout.href) + '" class="brand-axis__sub-pill' + (anyActive ? '' : ' brand-axis__sub-pill--active') + '" data-vp-drop="' + esc(tout.drop) + '">' + esc(allLabel) + '</a>';
          shownValues(group).forEach(function(value) {
            var link = axisHref(group, value, groups, 'h2');
            var page = group.key === 'series' ? seriesPages[value.value] : null;
            pills += '<a href="' + esc(page ? page.url : link.href) + '" class="brand-axis__sub-pill' + (value.active ? ' brand-axis__sub-pill--active' : '') + '" data-vp-drop="' + esc(link.drop) + '"' + (page ? ' data-vp-series-link data-vp-hero-srcset="' + esc(page.img || '') + '"' : '') + '>' + esc(value.label) + '</a>';
          });
          var label = group.label;
          if (group.key === 'series' && seriesLabel) label = seriesLabel;
          else if (group.key === 'brand' && brandLabel) label = brandLabel;
          else if (group.key === 'product_type' && typeLabel) label = typeLabel;
          html += '<div class="brand-axis__sub-row" data-vp-axis-row="h2" data-vp-axis-key="' + esc(group.key) + '"><span class="brand-axis__sub-label">' + esc(label) + '</span><div class="brand-axis__sub-pills">' + pills + '</div></div>';
        });
      }
      nav.innerHTML = html;
      if (window.vpBindAxisPills) window.vpBindAxisPills();
    }

    function rememberAliases(data) {
      (data.groups || []).concat(data.active || []).forEach(function(item) {
        if (!item || !item.param || !item.aliases || !item.aliases.length) return;
        aliasesByParam[item.param] = item.aliases.slice();
      });
    }

    function renderBar(root, data) {
      if (!data || !Array.isArray(data.groups)) return;
      rememberAliases(data);
      document.querySelectorAll('[data-vp-filter-groups]').forEach(function(node) {
        patchGroups(node, data);
      });
      paintAxis(data);
      var activeCount = (data.active || []).length;
      document.querySelectorAll('[data-vp-clear]').forEach(function(node) {
        node.hidden = activeCount === 0;
      });
      var badge = document.querySelector('[data-vp-active-count]');
      if (badge) {
        badge.hidden = activeCount === 0;
        badge.textContent = String(activeCount);
      }
      var active = document.querySelector('[data-vp-filter-active]');
      if (!active) return;
      if (!activeCount) {
        active.hidden = true;
        active.innerHTML = '';
        return;
      }
      active.hidden = false;
      active.innerHTML = data.active.map(function(item) {
        var legacyAttr = item.legacy ? ' data-vp-legacy="' + esc(item.legacy) + '"' : '';
        var aliasAttr = item.aliases && item.aliases.length ? ' data-vp-aliases="' + esc(item.aliases.join(',')) + '"' : '';
        return '<button type="button" class="collection-page__active-tag" data-vp-param="' + esc(item.param) + '" data-vp-value="' + esc(item.value) + '"' + legacyAttr + aliasAttr + '>' + esc(item.label) + closeIcon + '</button>';
      }).join('');
    }

    window.vpApplyCollectionUrl = function(next) {
      // Shopify's page number belongs to the unfiltered list, so it never survives a filter change or a vp page.
      var clean = new URL(next, window.location.href);
      clean.searchParams.delete('page');
      /* Keep a ?view= preview (template not yet assigned) across filter changes. */
      var view = new URL(window.location.href).searchParams.get('view');
      if (view && !clean.searchParams.has('view') && clean.pathname === window.location.pathname) clean.searchParams.set('view', view);
      next = clean.toString();
      var root = document.querySelector('[data-vp-filter-bar]');
      var error = root && root.querySelector('[data-vp-filter-error]');
      if (error) error.hidden = true;
      history.pushState({ vpCollection: 1 }, '', next);
      window.vpInitFilterBar();
    };

    function applyUrl(next) {
      window.vpApplyCollectionUrl(next);
    }

    function aliasNames(param, raw) {
      var names = [];
      function add(name) {
        if (!name || names.indexOf(name) !== -1) return;
        names.push(name);
      }
      String(raw || '').split(',').forEach(function(part) { add(part.trim()); });
      (aliasesByParam[param] || []).forEach(add);
      return names;
    }

    function toggleValue(param, value, legacy, aliasRaw) {
      var url = new URL(window.location.href);
      var current = url.searchParams.getAll(param);
      var legacyName = legacy || '';
      if (legacyName === 'filter.v.price') {
        url.searchParams.delete('filter.v.price.gte');
        url.searchParams.delete('filter.v.price.lte');
        legacyName = '';
      }
      var names = aliasNames(param, aliasRaw).filter(function(name) {
        return name !== param && name !== legacyName;
      });
      var legacyCurrent = legacyName ? url.searchParams.getAll(legacyName) : [];
      var aliasCurrent = [];
      names.forEach(function(name) {
        url.searchParams.getAll(name).forEach(function(item) {
          if (aliasCurrent.indexOf(item) === -1) aliasCurrent.push(item);
        });
      });
      var wasOn = current.indexOf(value) !== -1 || legacyCurrent.indexOf(value) !== -1 || aliasCurrent.indexOf(value) !== -1;
      url.searchParams.delete(param);
      if (legacyName) url.searchParams.delete(legacyName);
      names.forEach(function(name) { url.searchParams.delete(name); });
      url.searchParams.delete('vp.page');
      var next = wasOn
        ? current.filter(function(item) { return item !== value; })
        : current.concat([value]);
      var legacyBase = legacyCurrent.slice();
      aliasCurrent.forEach(function(item) {
        if (legacyBase.indexOf(item) === -1) legacyBase.push(item);
      });
      var legacyNext = wasOn
        ? legacyBase.filter(function(item) { return item !== value; })
        : legacyBase;
      if (!legacyName) {
        legacyNext.forEach(function(item) {
          if (next.indexOf(item) === -1) next.push(item);
        });
        legacyNext = [];
      }
      next.forEach(function(item) { url.searchParams.append(param, item); });
      if (legacyName) legacyNext.forEach(function(item) { url.searchParams.append(legacyName, item); });
      applyUrl(url.toString());
    }

    window.vpInitFilterBar = function() {
      var root = document.querySelector('[data-vp-filter-bar]');
      if (!root) return;
      var strings = stringsFrom(root);
      var pageUrl = new URL(window.location.href);
      var token = ++requestToken;
      var url = endpoint(root, pageUrl);
      var prefetch = window.vpFilterPrefetch;
      window.vpFilterPrefetch = null;
      var request = prefetch && prefetch.url === url
        ? prefetch.request
        : fetch(url, { headers: { Accept: 'application/json' } }).then(function(response) {
          if (!response.ok) throw new Error('vp-filters');
          return response.json();
        });
      request
        .then(function(data) {
          if (token !== requestToken) return;
          if (!data || typeof data.replaceGrid !== 'boolean') throw new Error('vp-filters');
          if (data.replaceGrid && !Array.isArray(data.products)) throw new Error('vp-filters');
          renderBar(root, data);
          var section = root.closest('.collection-page');
          var html = document.documentElement;
          if (data.replaceGrid) {
            /* The hidden first grid was unfiltered: replace it without the leave animation. */
            var hiddenGrid = html.classList.contains('vp-filter-pending') && section && section.querySelector('[data-vp-product-grid]');
            if (hiddenGrid) hiddenGrid.innerHTML = '';
            paintGrid(root, data, strings);
          } else if (section) restoreLiquid(section);
          html.classList.remove('vp-filter-pending');
          appliedUrl = window.location.href;
          var error = root.querySelector('[data-vp-filter-error]');
          if (error) error.hidden = true;
        })
        .catch(function() {
          if (token !== requestToken) return;
          document.documentElement.classList.remove('vp-filter-pending');
          var failedUrl = window.location.href;
          var narrowing = hasNarrowing(new URL(failedUrl));
          var painted = !!root.querySelector('[data-vp-filter-groups] .collection-page__filter-group');
          if (failedUrl !== appliedUrl) history.replaceState({}, '', appliedUrl);
          if (painted && !narrowing) return;
          var error = root.querySelector('[data-vp-filter-error]');
          if (error) {
            error.hidden = false;
            error.textContent = strings.error || '';
          }
        });
    };

    function closeMobileDrawer() {
      var panel = document.getElementById('collection-filters-mobile');
      if (!panel) return;
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function(event) {
      if (!document.querySelector('[data-vp-filter-bar]') || !event.target.closest) return;
      var clear = event.target.closest('[data-vp-clear]');
      if (clear) {
        if (clear.closest('#collection-filters-mobile')) closeMobileDrawer();
        var url = new URL(window.location.href);
        narrowingKeys(url).forEach(function(key) { url.searchParams.delete(key); });
        applyUrl(url.toString());
        return;
      }
      var button = event.target.closest('[data-vp-param]');
      if (button) {
        if (button.closest('#collection-filters-mobile')) closeMobileDrawer();
        toggleValue(button.getAttribute('data-vp-param'), button.getAttribute('data-vp-value'), button.getAttribute('data-vp-legacy'), button.getAttribute('data-vp-aliases'));
        return;
      }
      var page = event.target.closest('[data-vp-page]');
      if (page) {
        var next = new URL(window.location.href);
        next.searchParams.set('vp.page', page.getAttribute('data-vp-page'));
        scrollTopRequestedAt = Date.now();
        applyUrl(next.toString());
      }
    });

    function seedEmptyGroups() {
      var source = document.querySelector('[data-vp-filter-bar] [data-vp-filter-groups]');
      if (!source || !source.querySelector('.collection-page__filter-group')) return;
      document.querySelectorAll('[data-vp-filter-groups]').forEach(function(node) {
        if (node === source || node.querySelector('.collection-page__filter-group')) return;
        node.innerHTML = source.innerHTML;
      });
    }

    function bootFilterBar() {
      captureCleanLiquid();
      seedEmptyGroups();
      var root = document.querySelector('[data-vp-filter-bar]');
      if (!root) return;
      var pageUrl = new URL(window.location.href);
      var painted = !!root.querySelector('[data-vp-filter-groups] .collection-page__filter-group');
      if (painted && !hasNarrowing(pageUrl)) {
        var refresh = function() { window.vpInitFilterBar(); };
        if (window.requestIdleCallback) window.requestIdleCallback(refresh, { timeout: 1500 });
        else window.setTimeout(refresh, 1);
        return;
      }
      window.vpInitFilterBar();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootFilterBar);
    } else {
      bootFilterBar();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
